/* ================================================================
   NENSONS USER STORES
   Exact-order external JavaScript dispatcher.

   The Liquid page references THIS SAME FILE at the positions where each
   original inline script existed, using data-stage="...".
   That preserves the original execution timing while keeping only one
   physical JavaScript asset.
   ================================================================ */
(function () {
  var current = document.currentScript;
  var stage = current && current.dataset ? current.dataset.stage : "";
  switch (stage) {
    case "widget":
      (function () {

/* ─── SHOPIFY IMAGE URL HELPER ─────────────────────────────── */
function shopifyResizedUrl(src, width, height) {
  if (!src) return src;
  let url = src.replace(/_\d+x\d+(_crop_\w+)?(\.[a-z]+)(\?|$)/, '$2$3');
  const ext = url.match(/\.[a-z]+(\?|$)/);
  if (!ext) return src;
  const suffix = `_${width}x${height}_crop_center`;
  url = url.replace(/(\.[a-z]+)(\?|$)/, `${suffix}$1$2`);
  return url;
}

/* ─── PRODUCTS ──────────────────────────────────────────────── */
// Shopify Liquid generates this array immediately before this stage runs.
let products = Array.isArray(window.NENSON_WIDGET_PRODUCTS)
  ? window.NENSON_WIDGET_PRODUCTS
  : [];

// Always have fallback products ready
const FALLBACK_PRODUCTS = [
  {
    url: 'https://www.nensons.com/pages/binder-oficial',
    img: 'https://images.unsplash.com/photo-1523381210434-271e8be1f52b?w=400&h=560&fit=crop&auto=format'
  },
  {
    url: 'https://www.nensons.com/pages/binder-oficial',
    img: 'https://images.unsplash.com/photo-1612178537253-bccd437b730e?w=400&h=560&fit=crop&auto=format'
  },
  {
    url: 'https://www.nensons.com/pages/binder-oficial',
    img: 'https://images.unsplash.com/photo-1621600415092-694aadf9cbb7?w=400&h=560&fit=crop&auto=format'
  },
  {
    url: 'https://www.nensons.com/pages/binder-oficial',
    img: 'https://images.unsplash.com/photo-1605979257913-1704eb7b6246?w=400&h=560&fit=crop&auto=format'
  }
];

// Ensure we always have at least 4 products for the animation
const expandedProducts = [];
const availableCount = products.length;

if (availableCount > 0) {
  // Use real products if available
  for (let i = 0; i < 28; i++) {
    expandedProducts.push(products[i % availableCount]);
  }
} else {
  // Use fallback products if no real products
  console.log('📦 Using fallback products for animation');
  for (let i = 0; i < 28; i++) {
    expandedProducts.push(FALLBACK_PRODUCTS[i % FALLBACK_PRODUCTS.length]);
  }
}

// Log what we're using
console.log(`🎴 Animation using ${expandedProducts.length} cards (${availableCount > 0 ? 'real' : 'fallback'} products)`);

const container = document.getElementById('cardSkinContainer');
const box       = document.getElementById('box');
const hotspot   = document.getElementById('titleHotspot');
const textBlock = document.getElementById('textBlock');
const DPR       = Math.min(window.devicePixelRatio || 1, 3);

/* ─── POSITION HOTSPOT TO TEXT CONTENT WIDTH ────────────────────
   .text is inline-block so tRect is exactly the text content size.
   We add a small padding so the rectangle hugs the letters tightly.
─────────────────────────────────────────────────────────────── */
function positionHotspot() {
  if (!hotspot || !textBlock || !box) return;

  const tRect = textBlock.getBoundingClientRect();
  const bRect = box.getBoundingClientRect();

  const padH   = 16;
  const padV   = 12;
  const nudge  = 20; /* ← increase this number to push it further down */

  const textCenterX = (tRect.left + tRect.right) / 2 - bRect.left;
const hotspotW    = tRect.width + padH * 2;
hotspot.style.left   = (textCenterX - hotspotW / 2) + 'px';
hotspot.style.top    = (tRect.top  - bRect.top  - padV + nudge) + 'px';
hotspot.style.width  = hotspotW + 'px';
hotspot.style.height = (tRect.height + padV * 2) + 'px';

  if (!hotspot.dataset.heightLocked) {
    hotspot.dataset.heightLocked = '1';
    hotspot.dataset.lockedHeight = hotspot.style.height;
  } else {
    hotspot.style.height = hotspot.dataset.lockedHeight;
  }
}

/* ─── CARD DISTRIBUTION ─────────────────────────────────────── */
function distributeCards() {
  if (!container) return;
  container.innerHTML = '';

  const boxRect = box.getBoundingClientRect();
  const width   = boxRect.width;
  const height  = boxRect.height;

  if (width < 100 || height < 100) { setTimeout(distributeCards, 50); return; }

  const isMobile   = window.innerWidth <= 600;
  const textTop    = isMobile ? 50  : 70;
  const textBottom = isMobile ? 150 : 180;
  const textLeft   = width  * (isMobile ? 0.15 : 0.2);
  const textRight  = width  * (isMobile ? 0.85 : 0.8);
  const rows       = isMobile ? 6 : 5;
  const cols       = isMobile ? 5 : 6;
  const cardCount  = 28;

  const gridPositions = [];
  for (let row = 0; row < rows; row++)
    for (let col = 0; col < cols; col++)
      gridPositions.push({ baseX:(col/cols)*width, baseY:(row/rows)*height, used:false });

  for (let i = gridPositions.length-1; i > 0; i--) {
    const j = Math.floor(Math.random()*(i+1));
    [gridPositions[i], gridPositions[j]] = [gridPositions[j], gridPositions[i]];
  }

  for (let i = 0; i < cardCount; i++) {
    let sizeClass, w_card, h_card;
    const rand = Math.random();

    if (isMobile) {
      if      (rand < 0.50) { sizeClass='small';  w_card=32; h_card=43; }
      else if (rand < 0.85) { sizeClass='medium'; w_card=42; h_card=56; }
      else                  { sizeClass='large';  w_card=54; h_card=72; }
    } else {
      if      (rand < 0.30) { sizeClass='small';  w_card=48; h_card=64;  }
      else if (rand < 0.70) { sizeClass='medium'; w_card=64; h_card=85;  }
      else                  { sizeClass='large';  w_card=82; h_card=109; }
    }

    const isHero = Math.random() < 0.15;
    const imgW   = Math.round(w_card * DPR);
    const imgH   = Math.round(h_card * DPR);

    let left, top, validPosition = false, attempts = 0;

    while (!validPosition && attempts < 50) {
      const pos = gridPositions[Math.floor(Math.random()*gridPositions.length)];
      if (!pos.used) {
        const cellWidth  = width  / cols;
        const cellHeight = height / rows;
        left = pos.baseX + (Math.random()-.5)*cellWidth *0.7;
        top  = pos.baseY + (Math.random()-.5)*cellHeight*0.7;
        left = Math.max(5, Math.min(left, width  - w_card - 5));
        top  = Math.max(5, Math.min(top,  height - h_card - 5));
        const cx = left + w_card/2, cy = top + h_card/2;
        const inZone = cx>textLeft && cx<textRight && cy>textTop && cy<textBottom;
        if (!inZone || Math.random() < (isMobile ? 0.15 : 0.2)) { validPosition=true; pos.used=true; }
      }
      attempts++;
    }

    if (!validPosition) {
      left = 10 + Math.random()*(width  - w_card - 20);
      top  = 10 + Math.random()*(height - h_card - 20);
    }

    const cx = left + w_card/2, cy = top + h_card/2;
    const isBehindTitle = cx>textLeft && cx<textRight && cy>textTop && cy<textBottom;

    const card = document.createElement('div');
    card.className = `card-skin ${sizeClass}${isHero?' hero':''}${isBehindTitle?' behind-title':''}`;
    card.style.cssText = `
      left:${left}px; top:${top}px;
      transform:rotate(${(Math.random()-.5)*(isMobile?8:10)}deg);
      z-index:${isHero ? 10 : Math.floor(Math.random()*8)+1};
      opacity:${isHero ? 1 : 0.7+Math.random()*0.2};
    `;

    const product = expandedProducts[i % expandedProducts.length];
    const link    = document.createElement('a');
    link.href     = product.url || 'https://www.nensons.com/pages/binder-oficial';

    if (product && product.img) {
  const img = document.createElement('img');
  img.alt = 'NENSON binder card';
  img.loading = 'lazy';
  img.decoding = 'async';
  
  // Add error handling for images
  img.onerror = function() {
    this.src = 'https://images.unsplash.com/photo-1523381210434-271e8be1f52b?w=400&h=560&fit=crop&auto=format';
    this.onerror = null; // Prevent infinite loop
  };
  
  const src1x = shopifyResizedUrl(product.img, imgW, imgH);
  img.src = src1x;
  if (DPR > 1) img.srcset = `${src1x} 1x, ${shopifyResizedUrl(product.img, imgW*2, imgH*2)} 2x`;
  img.style.background = '#111';
  link.appendChild(img);
} else {
  link.innerHTML = '<div style="width:100%;height:100%;background:#1e1e1e;"></div>';
}

    card.appendChild(link);
    container.appendChild(card);
  }

  /* Corner accent cards */
  const corners = [
    { left:5,                              top:5 },
    { left:width-(isMobile?38:58),         top:5 },
    { left:5,                              top:height-(isMobile?48:69) },
    { left:width-(isMobile?38:58),         top:height-(isMobile?48:69) }
  ];

  corners.forEach((pos, idx) => {
    const w_card = isMobile?32:48, h_card = isMobile?43:64;
    const imgW = Math.round(w_card*DPR), imgH = Math.round(h_card*DPR);
    const cc   = document.createElement('div');
    cc.className = 'card-skin small';
    cc.style.cssText = `left:${pos.left}px;top:${pos.top}px;transform:rotate(${idx*5-5}deg);z-index:3;opacity:0.9;`;
    const product = expandedProducts[(idx+24)%expandedProducts.length];
    if (product && product.img) {
      const link = document.createElement('a');
      link.href  = product.url || 'https://www.nensons.com/pages/binder-oficial';
      const img  = document.createElement('img');
      img.alt = 'corner card'; img.loading='lazy'; img.decoding='async';
      const src1x = shopifyResizedUrl(product.img, imgW, imgH);
      img.src = src1x;
      if (DPR > 1) img.srcset = `${src1x} 1x, ${shopifyResizedUrl(product.img, imgW*2, imgH*2)} 2x`;
      link.appendChild(img);
      cc.appendChild(link);
    }
    container.appendChild(cc);
  });

  requestAnimationFrame(positionHotspot);
}

/* ─── GRID CANVAS ───────────────────────────────────────────── */
const canvas = document.getElementById('gridCanvas');
const ctx    = canvas.getContext('2d');
let W, H;

function resizeCanvas() {
  if (!box) return;
  W = canvas.width  = box.offsetWidth;
  H = canvas.height = box.offsetHeight;
}
resizeCanvas();

const CELL = 56, LINE_COLOR = '#D10000';
let lines  = [];

function spawnLine() {
  const isX   = Math.random() > 0.42;
  const len   = CELL*(2+Math.floor(Math.random()*5));
  const speed = 1.2+Math.random()*2.2;
  let x,y,dx,dy;
  if (isX) {
    y=Math.floor(Math.random()*Math.ceil(H/CELL))*CELL;
    const r=Math.random()>0.5; x=r?-len:W+len; dx=r?speed:-speed; dy=0;
  } else {
    x=Math.floor(Math.random()*Math.ceil(W/CELL))*CELL;
    const d=Math.random()>0.5; y=d?-len:H+len; dx=0; dy=d?speed:-speed;
  }
  return {x,y,dx,dy,len,color:LINE_COLOR,isX,alpha:0,born:0,life:0};
}

for (let i=0;i<8;i++){const l=spawnLine();l.born=-Math.random()*200;lines.push(l);}

function hexToRgb(hex){
  return `${parseInt(hex.slice(1,3),16)},${parseInt(hex.slice(3,5),16)},${parseInt(hex.slice(5,7),16)}`;
}

function draw() {
  ctx.clearRect(0,0,W,H);
  ctx.strokeStyle='rgba(255,255,255,0.04)'; ctx.lineWidth=0.5;
  for(let x=0;x<W;x+=CELL){ctx.beginPath();ctx.moveTo(x,0);ctx.lineTo(x,H);ctx.stroke();}
  for(let y=0;y<H;y+=CELL){ctx.beginPath();ctx.moveTo(0,y);ctx.lineTo(W,y);ctx.stroke();}
  for(let x=0;x<=W;x+=CELL) for(let y=0;y<=H;y+=CELL){
    ctx.beginPath();ctx.arc(x,y,1,0,Math.PI*2);
    ctx.fillStyle='rgba(255,255,255,0.07)';ctx.fill();
  }
  for(let i=lines.length-1;i>=0;i--){
    const l=lines[i]; l.born++; if(l.born<0)continue; l.life++; l.x+=l.dx; l.y+=l.dy;
    const pos=l.isX?l.x:l.y, total=l.isX?W+l.len*2:H+l.len*2;
    const t=(pos+l.len+(l.isX?W:H))/(total+l.len*2);
    const fade=Math.sin(Math.min(t,1-t)*Math.PI*2);
    if(fade<=0||l.life>400){lines.splice(i,1);lines.push(spawnLine());continue;}
    const ex=l.isX?l.x+l.len:l.x, ey=l.isX?l.y:l.y+l.len, rgb=hexToRgb(l.color);
    [12,5,2].forEach((bw,bi)=>{
      const a=[0.06,0.15,0.7][bi]*fade;
      const grad=ctx.createLinearGradient(l.x,l.y,ex,ey);
      grad.addColorStop(0,`rgba(${rgb},0)`);
      grad.addColorStop(0.2,`rgba(${rgb},${a})`);
      grad.addColorStop(0.7,`rgba(${rgb},${a})`);
      grad.addColorStop(1,`rgba(${rgb},0)`);
      ctx.strokeStyle=grad; ctx.lineWidth=bw; ctx.lineCap='round';
      ctx.beginPath(); ctx.moveTo(l.x,l.y); ctx.lineTo(ex,ey); ctx.stroke();
    });
    ctx.beginPath(); ctx.arc(ex,ey,2.5,0,Math.PI*2);
    ctx.fillStyle=`rgba(${rgb},${fade*0.9})`;
    ctx.shadowColor=l.color; ctx.shadowBlur=10; ctx.fill(); ctx.shadowBlur=0;
  }
  requestAnimationFrame(draw);
}
draw();

/* ─── INIT & EVENTS ─────────────────────────────────────────── */
window.addEventListener('resize', () => {
  resizeCanvas();
  distributeCards();
  positionHotspot();
});

setTimeout(() => { resizeCanvas(); distributeCards(); }, 100);

window.addEventListener('load', () => {
  resizeCanvas();
  distributeCards();
  setTimeout(positionHotspot, 150);
  setTimeout(positionHotspot, 500);
});

/* Whole-box click fallback — only when NOT clicking a link */
const wrapBox = document.getElementById('wrapBox');
if (wrapBox) {
  wrapBox.addEventListener('click', function(e) {
    if (e.target.closest('a')) return;
    window.location.href = 'https://www.nensons.com/pages/binder-oficial';
  });
}
      })();
      break;
    case "tutorial-inject":
      (function () {

(function injectBinderTutorialButton() {
  function tryInject() {
    const wrap = document.querySelector('.bulk-publish-all-wrap');
    if (!wrap) { setTimeout(tryInject, 120); return; }
    if (document.getElementById('binder-tutorial-btn')) return;

    const btn = document.createElement('button');
    btn.id = 'binder-tutorial-btn';
    btn.type = 'button';
    btn.innerHTML = '<span class="btn-icon">?</span> ¿Cómo funciona? Ver tutorial';
    btn.addEventListener('click', startBinderTutorial);
    wrap.insertAdjacentElement('afterend', btn);

    /* ── Build unified top bar: [search input] [rating sorter] ── */
    const searchBar = document.getElementById('global-search-bar');
    if (!searchBar || document.getElementById('nb-top-bar')) return;

    const topBar = document.createElement('div');
    topBar.id = 'nb-top-bar';

    /* Move the search bar div into the top bar */
    searchBar.parentNode.insertBefore(topBar, searchBar);
    topBar.appendChild(searchBar);

    /* Rating sorter may already exist or get injected later — watch for it */
    const existingSorter = document.getElementById('nb-rating-sorter');
    if (existingSorter) {
      topBar.appendChild(existingSorter);
    } else {
      /* MutationObserver picks it up when addRatingSorter() runs */
      const observer = new MutationObserver(() => {
        const sorter = document.getElementById('nb-rating-sorter');
        if (sorter && sorter.parentNode !== topBar) {
          topBar.appendChild(sorter);
          observer.disconnect();
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }
  tryInject();
})();
      })();
      break;
    case "tutorial-steps":
      (function () {

/* ============================================================
   BINDER STORES — Tutorial Steps
   Each step targets a real element on the page.
   onHighlightStarted scrolls the element into view.
============================================================ */
const BINDER_TUTORIAL_STEPS = [
  {
    element: '.binders-title',
    title: '🗂️ Bienvenid@ a Binder Stores',
    description: 'Aquí encontrarás los binders (carpetas) de todos los vendedores de Nensons. Cada vendedor tiene su propia colección de tarjetas para explorar y comprar.',
    side: 'bottom', align: 'center'
  },
  {
    element: '#global-search-bar',
    title: '🔍 Búsqueda Global',
    description: 'Usa esta barra para buscar tarjetas por nombre, vendedor o etiqueta (tag). Los resultados filtran en tiempo real mostrando sólo los vendedores y productos que coincidan.',
    side: 'bottom', align: 'center'
  },
  {
    element: '.bulk-help-badge',
    title: '❓ Botón de Ayuda',
    description: 'Pasa el cursor sobre este botón en cualquier momento para ver un resumen rápido de cómo navegar el sitio. Siempre está disponible aquí arriba.',
    side: 'bottom', align: 'start'
  },
  {
    element: '.vendor-group',
    title: '🏪 Tarjeta de Vendedor',
    description: 'Cada tarjeta representa a un vendedor. Verás su nombre, una vista previa de sus tarjetas, su calificación y un enlace a sus reseñas. Haz clic en el banner del vendedor para abrir su binder completo.',
    side: 'right', align: 'start'
  },
  {
    element: '.vendor-rating-cta',
    title: '⭐ Calificación del Vendedor',
    description: 'Esta insignia muestra el promedio de calificación del vendedor (escala 1–10). Los colores cambian según el nivel: negro → bronce → plata → oro → diamante. ¡Haz clic para calificar tú mismo!',
    side: 'bottom', align: 'start'
  },
  {
    element: '.vendor-article-link',
    title: '💬 Reseñas del Vendedor',
    description: 'Haz clic aquí para leer las reseñas y experiencias de otros compradores con este vendedor. Muy útil antes de hacer tu primera compra.',
    side: 'top', align: 'start'
  },
  {
    element: '.carousel',
    title: '🎴 Vista Previa del Binder',
    description: 'Estas son las primeras tarjetas del binder del vendedor. Puedes desplazarte horizontalmente para ver más. Haz clic en cualquier tarjeta para ir al producto.',
    side: 'top', align: 'center'
  },
  {
    element: '.add-to-cart-btn',
    title: '➕ Agregar al Carrito',
    description: 'Haz clic en este botón azul sobre cualquier tarjeta para añadirla directamente a tu carrito, sin salir de la página. El botón cambia a ✅ cuando se agrega correctamente.',
    side: 'top', align: 'center'
  },
  {
    element: '.quantity-badge',
    title: '📦 Disponibilidad en Stock',
    description: 'Este número indica cuántas unidades quedan disponibles. Verde = suficiente stock, amarillo = pocas unidades, rojo = sin stock. Se actualiza en tiempo real.',
    side: 'left', align: 'center'
  },
  {
    element: '#binder-tutorial-btn',
    title: '🚀 ¡Ya estás list@!',
    description: 'Ahora sabes cómo funciona Binder Stores. Explora los binders de tus vendedores favoritos, agrega tarjetas al carrito y califica tu experiencia. ¡Que disfrutes la caza de cartas!',
    side: 'top', align: 'center'
  }
];

let _binderDriver = null;

/* Safely get the first matching element visible in the DOM */
function _binderEl(selector) {
  if (!selector) return null;
  return document.querySelector(selector) || null;
}

function startBinderTutorial() {
  if (!window.driver || !window.driver.js) {
    console.error('Driver.js not loaded yet');
    return;
  }
  if (_binderDriver) return;

  /* On phones, force every popover below its element and centred —
     this prevents the card from sliding off left/right edges */
  const isMobile = window.innerWidth <= 640;

  const steps = BINDER_TUTORIAL_STEPS
    .filter(s => !s.element || _binderEl(s.element))
    .map(s => ({
      element: s.element ? _binderEl(s.element) : undefined,
      popover: {
        title:       s.title,
        description: s.description,
        side:        isMobile ? 'bottom' : s.side,
        align:       isMobile ? 'center' : s.align
      },
      onHighlightStarted: (el) => {
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }));

  _binderDriver = window.driver.js.driver({
    showProgress:  true,
    allowClose:    true,
    nextBtnText:   'Siguiente →',
    prevBtnText:   '← Atrás',
    doneBtnText:   '¡Listo! 🎉',
    progressText:  '{{current}} de {{total}}',
    smoothScroll:  true,
    steps,
    onDestroyStarted: () => {
      _binderDriver.destroy();
      _binderDriver = null;
    }
  });

  setTimeout(() => _binderDriver.drive(), 100);
}
      })();
      break;
    case "header-helper":
      (function () {

(function nbHeaderHeightVar(){
  const root = document.documentElement;

  function pickHeaderEls(){
  const header =
    document.querySelector('sticky-header') ||
    document.querySelector('#shopify-section-header') ||
    document.querySelector('.header-wrapper') ||
    document.querySelector('header');

  const announce =
    document.querySelector('#shopify-section-announcement-bar') ||
    document.querySelector('.announcement-bar') ||
    document.querySelector('[data-section-type="announcement-bar"]');

  return { header, announce };
}

function set(){
  const { header, announce } = pickHeaderEls();

  const h1 = header ? Math.round(header.getBoundingClientRect().height || 0) : 0;
  const h2 = announce ? Math.round(announce.getBoundingClientRect().height || 0) : 0;

  const h = Math.max(0, h1 + h2);
  document.documentElement.style.setProperty('--nb-header-h', (h || 64) + 'px');
}

  set();
  window.addEventListener('resize', set, { passive:true });
  window.addEventListener('orientationchange', set, { passive:true });

  // Track dynamic header height (announcement bar, sticky collapse, etc.)
  if ('ResizeObserver' in window) {
    const ro = new ResizeObserver(() => set());
    const hEl = pickHeaderEls().header;
    if (hEl) ro.observe(hEl);
  }
})();
      })();
      break;
    case "preconnect":
      (function () {

/* Preconnect to Shopify CDN and API */
(function preconnect(){
  try{
    const head=document.head||document.getElementsByTagName('head')[0];
    const mk=(href)=>{ const l=document.createElement('link'); l.rel='preconnect'; l.href=href; l.crossOrigin='anonymous'; head.appendChild(l); };
    mk('https://cdn.shopify.com');
    const a=document.createElement('a'); a.href=(window.API_BASE||''); mk(a.origin);
  }catch{}
})();
      })();
      break;
    case "binder-core":
      (function () {

/* ================== Constants & micro scheduler ================== */
window.__BINDER_API_BASE = API_BASE;
const BINDER_LIST_URL = () => `${getApiBaseOrThrow()}/list-binder-products`;
const INVENTORY_ENDPOINT_CANDIDATES = () => [
  apiUrl('variant-inventory-bulk'),
  apiUrl('get-variant-inventory'),
  apiUrl('variant-inventory'),
  apiUrl('inventory'),
];


/* micro scheduler to batch UI work */
const Sched = (() => {
  let rafQueued=false, rafJobs=new Set();
  const runRaf = () => { rafQueued=false; const jobs=[...rafJobs]; rafJobs.clear(); for (const f of jobs) try{f()}catch(e){console.error(e)} };
  return {
    raf(fn){ rafJobs.add(fn); if (!rafQueued){ rafQueued=true; requestAnimationFrame(runRaf); } },
    idle(fn, t=120){ if ('requestIdleCallback' in window) requestIdleCallback(fn,{timeout:t}); else setTimeout(fn, t); },
    micro(fn){ Promise.resolve().then(fn); }
  };
})();

/* ================== Perf caches ================== */
const INV_CACHE = new Map();        // variantId -> qty
const PROD_CACHE = new Map();       // handle -> product.json
const VARIANT_RESOLVE_CACHE = new Map(); // handle|sku -> variantId
const SEEN_FRAME = new WeakSet();   // processed frames

// ===== Vendor rating average cache =====
const VENDOR_RATING_AVG_CACHE = new Map(); // vendorKey -> { avg, count, ts }
const VENDOR_RATING_AVG_INFLIGHT = new Map(); // vendorKey -> Promise

// ✅ User rating hot cache (instant modal paint)
const USER_RATING_CACHE = new Map(); // key -> { score, ts }
// ✅ Already-rated server result cache (avoid re-hitting endpoint)
const VENDOR_RATING_ALREADY_CACHE = new Map(); // key -> { alreadyRated, score, ts }
const VENDOR_RATING_ALREADY_INFLIGHT = new Map(); // key -> Promise

function userRatingCacheKey(vendorKey, vendorEmail=""){
  const vk = getRatingVendorKey(vendorKey, vendorEmail);
  const ve = canonicalizeEmail(vendorEmail || "") || vk;
  const uid = VENDOR_RATING.userId();
  return `${vk}|${ve}|${uid}`;
}

function getUserRatingLocalFast(vendorKey, vendorEmail=""){
  try{
    const vk = getRatingVendorKey(vendorKey, vendorEmail);
    const uid = VENDOR_RATING.userId();
    const raw = localStorage.getItem(VENDOR_RATING.localKey(vk));
    if (!raw) return 0;
    const j = JSON.parse(raw);
    const s = Number(j?.byUser?.[uid] || 0);
    return (s >= 1 && s <= 10) ? s : 0;
  }catch{ return 0; }
}

function cacheSetWithCap(map, key, value, cap){
  map.set(key, value);
  if (cap && map.size > cap){
    const first = map.keys().next().value;
    map.delete(first);
  }
}

/* ================== Mobile visualViewport normalizer ================== */

(function mobileViewportFix(){
  const root = document.documentElement;
  const set = () => {
    const vv = window.visualViewport;
    const vw = Math.round(vv?.width  || window.innerWidth  || document.documentElement.clientWidth);
    const vh = Math.round(vv?.height || window.innerHeight || document.documentElement.clientHeight);
    root.style.setProperty('--app-vw', vw + 'px');
    root.style.setProperty('--app-vh', vh + 'px');
    Sched.raf(() => { try { if (typeof fitAllSlabs === 'function') fitAllSlabs(document.getElementById('binder-content') || document); } catch{} });
  };
  set();
  window.addEventListener('resize', set, { passive: true });
  window.addEventListener('orientationchange', set, { passive: true });
  if (window.visualViewport) {
    visualViewport.addEventListener('resize', set, { passive: true });
    visualViewport.addEventListener('scroll', set, { passive: true });
  }
})();

function getRatingVendorKey(vendorKey, vendorEmail){
  // HARD RULE: rating key is canonical email when possible
  const emailKey =
    canonicalizeEmail(vendorEmail || "") ||
    canonicalizeEmail(vendorKey || "");

  if (emailKey) return emailKey;

  // fallback only if you truly have no email identity
  const k = String(vendorKey || "").trim();
  return k ? k.toLowerCase() : "";
}

/* =================== Helpers =================== */
function canonicalizeEmail(s = "") {
  const [userPart, domainPart] = String(s).trim().toLowerCase().split("@");
  if (!userPart || !domainPart) return "";
  if (domainPart === "gmail.com" || domainPart === "googlemail.com") {
    const user = userPart.split("+")[0].replace(/\./g, "");
    return `${user}@gmail.com`;
  }
  return `${userPart}@${domainPart}`;
}

function markWired(el) {
  if (!el) return;
  el.dataset.wired = "true";
  el.__wired = true;
}

// NEW — add once near helpers
function escHtml(s=""){
  return String(s).replace(/[&<>"']/g, m => (
    m === "&" ? "&amp;" :
    m === "<" ? "&lt;"  :
    m === ">" ? "&gt;"  :
    m === '"' ? "&quot;": "&#39;"
  ));
}

/* ─── Clean URL Slug Logic (Sync this with your backend) ──────────────────── */

function vendorArticleHandle(canonKey, vendorName = "") {
  return String(vendorName || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") // Remove accents
    .replace(/[^a-z0-9]+/g, "-")     // Replace spaces/special chars with dash
    .replace(/^-|-$/g, "")           // Trim leading/trailing dashes
    || "vendor";
}

/* ─── Canonical public slug (URL-safe, no PII) ─────────────── */
function storeSlug(s){
  return String(s || "")
    .toLowerCase()
    .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
}

/* Every slug a bucket could legitimately be addressed by.
   Tolerant on purpose: the PDP only knows product.vendor, which may
   not be byte-identical to bucket.userStore. */
function bucketSlugs(bucket, key, profile){
  const out = new Set();
  [
    bucket?.userStore, bucket?.user_store, profile?.user_store,
    bucket?.vendorName, profile?.vendor_name, bucket?.vendorLastName, key
  ].forEach(c => { const s = storeSlug(c); if (s) out.add(s); });
  return out;
}

function vendorArticleUrl(canonKey, bucketArticleUrl, vendorName = "") {
  // If the bucket already has a URL, use it
  if (bucketArticleUrl && String(bucketArticleUrl).startsWith("/blogs/")) {
    return String(bucketArticleUrl);
  }
  // Otherwise, generate the clean URL
  return `/blogs/vendedores/${vendorArticleHandle(canonKey, vendorName)}`;
}

function ratingTierFromAvg(avg) {
  const a = Number(avg);
  // NOTE: In your system "unrated" class is the BLACK tier (and also 0 votes).
  if (!Number.isFinite(a) || a <= 0) return "unrated"; // 0 / invalid -> BLACK

  // 1.0–5.9 = BLACK
  if (a <= 5.9) return "unrated";
  // 6.0–7.9 = BRONZE
  if (a <= 7.9) return "bronze";
  // 8.0–8.7 = SILVER
  if (a <= 8.7) return "silver";
  // 8.8–9.4 = GOLD
  if (a <= 9.4) return "gold";
  // 9.5–10.0 = DIAMOND
  return "diamond";
}

function ratingTierFromSummary(avg, count){
  const c = Number(count);
  // 0 votes (or invalid) => BLACK/unrated
  if (!Number.isFinite(c) || c <= 0) return "unrated";
  return ratingTierFromAvg(avg);
}

function tierClassName(tier){
  return tier ? `is-${tier}` : "";
}

// Smooth crossfade of the tier gradient layer
function fadeTierTo(ctaEl){
  if (!ctaEl) return;
  // kick opacity down then up next frame to animate
  ctaEl.style.setProperty('--tier-o', '0');
  requestAnimationFrame(() => {
    ctaEl.style.setProperty('--tier-o', '1');
  });
}

function applyTierClassToCtas(vendorKey, tier){
  const base = `.vendor-button[data-vendor-key="${CSS.escape(vendorKey)}"] .vendor-rating-cta`;
  const next = tier || "";
  Sched.raf(() => {
    document.querySelectorAll(base).forEach(cta => {
      const prev = cta.dataset.tier || "";
      if (prev === next) return; // nothing to do

      cta.classList.remove("is-unrated","is-bronze","is-silver","is-gold","is-diamond");
      if (next) cta.classList.add(`is-${next}`);
      cta.dataset.tier = next;

      // ✅ animate tier gradient crossfade
      fadeTierTo(cta);
    });
  });
}
(function addRatingSorter() {
  function tryInjectSorter() {
    if (document.getElementById('nb-rating-sorter')) return;

    const btn = document.getElementById('binder-tutorial-btn');
    if (!btn) { setTimeout(tryInjectSorter, 150); return; }

    const sorter = document.createElement('button');
    sorter.id = 'nb-rating-sorter';
    sorter.innerHTML = '★ Rating ↓';
    sorter.setAttribute('aria-label', 'Ordenar por rating');

    let sortDir = 'desc';

    sorter.style.cssText = `
      display: inline-flex;
      align-items: center;
      gap: 8px;
      background: #fff;
      color: #D10000;
      border: 2px solid #D10000;
      border-radius: 50px;
      padding: clamp(10px, 2vw, 14px) clamp(18px, 4vw, 28px);
      font-size: clamp(1rem, 2.2vw, 1.15rem);
      font-weight: 700;
      cursor: pointer;
      box-shadow: 0 2px 10px rgba(0,0,0,0.07);
      transition: all 0.2s ease;
      font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
      margin-top: 14px;
      white-space: nowrap;
    `;

    sorter.addEventListener('mouseenter', () => {
      sorter.style.background = '#D10000';
      sorter.style.color = '#fff';
      sorter.style.transform = 'translateY(-1px)';
      sorter.style.boxShadow = '0 4px 16px rgba(209,0,0,0.3)';
    });
    sorter.addEventListener('mouseleave', () => {
      sorter.style.background = '#fff';
      sorter.style.color = '#D10000';
      sorter.style.transform = 'translateY(0)';
      sorter.style.boxShadow = '0 2px 10px rgba(0,0,0,0.07)';
    });

    function getVendorRating(section) {
      const score = section.querySelector('.vendor-rating-cta .score');
      if (score) {
        const n = parseFloat(score.textContent);
        if (Number.isFinite(n)) return n;
      }
      const key = section.dataset.vendorKey || section.dataset.company || '';
      const bucket = window.__fullVendorData?.[key];
      const avg = Number(bucket?.vendorRatingAvg ?? bucket?.vendorRating ?? 0);
      return Number.isFinite(avg) ? avg : 0;
    }

    function applySort() {
      const container = document.getElementById('vendor-section');
      if (!container) return;
      const sections = Array.from(container.querySelectorAll('.vendor-group'));
      if (!sections.length) return;
      sections.sort((a, b) => {
        const ra = getVendorRating(a);
        const rb = getVendorRating(b);
        return sortDir === 'desc' ? rb - ra : ra - rb;
      });
      sections.forEach(s => container.appendChild(s));
    }

    sorter.addEventListener('click', () => {
      sortDir = sortDir === 'desc' ? 'asc' : 'desc';
      sorter.innerHTML = sortDir === 'desc' ? '★ Rating ↓' : '★ Rating ↑';
      applySort();
    });

    btn.insertAdjacentElement('afterend', sorter);
    applySort();
  }
  tryInjectSorter();
})();

(function addScrollTopBtn() {
  if (document.getElementById('nb-vendors-scroll-top')) return;

  const btn = document.createElement('button');
  btn.id = 'nb-vendors-scroll-top';
  btn.innerHTML = '↑';
  btn.setAttribute('aria-label', 'Volver arriba');
  btn.style.cssText = `
    position: fixed;
    bottom: 20px;
    left: 24px;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: rgba(209,0,0,0.9);
    color: #fff;
    border: none;
    font-size: 1.3rem;
    cursor: pointer;
    z-index: 9999;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.25s ease, transform 0.25s ease;
    box-shadow: 0 4px 16px rgba(0,0,0,0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    transform: translateY(10px);
  `;

  document.body.appendChild(btn);

  function show() {
    btn.style.opacity = '1';
    btn.style.pointerEvents = 'auto';
    btn.style.transform = 'translateY(0)';
  }
  function hide() {
    btn.style.opacity = '0';
    btn.style.pointerEvents = 'none';
    btn.style.transform = 'translateY(10px)';
  }

  window.addEventListener('scroll', function() {
    window.scrollY > 300 ? show() : hide();
  }, { passive: true });

  btn.addEventListener('click', function() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
})();

/* =========================
   Vendor Rating System
   - 1 vote per user per vendor
   - 10-star selection (1..10)
   - avg = totalScore / numRaters (10/1 = 10)
========================= */

const VENDOR_RATING = {
  alreadyUrl: (vendorKey, vendorEmail, userId) => {
    const vk = getRatingVendorKey(vendorKey, vendorEmail);
    const ve = canonicalizeEmail(vendorEmail || "") || vk;
    const qs = new URLSearchParams({ vendorKey: vk, vendorEmail: ve, userId });
    return `${apiUrl("vendor-rating/already")}?${qs.toString()}`;
  },

  summaryUrl: (vendorKey, vendorEmail) => {
    const vk = getRatingVendorKey(vendorKey, vendorEmail);
    const ve = canonicalizeEmail(vendorEmail || "") || vk;
    const qs = new URLSearchParams({ vendorKey: vk, vendorEmail: ve });
    return `${apiUrl("vendor-rating/summary")}?${qs.toString()}`;
  },

  submitUrl: () => apiUrl("vendor-rating/submit"),
  localKey: (vendorKey) => `nb:vendor-rating:${vendorKey}`,

  userId: () => {
    const email = canonicalizeEmail(window.CURRENT_CUSTOMER_EMAIL || "");
    if (email) return email;

    const k = "nb:anonUserId";
    let id = localStorage.getItem(k);
    if (!id) {
      id = "anon_" + Math.random().toString(16).slice(2) + "_" + Date.now().toString(16);
      localStorage.setItem(k, id);
    }
    return id;
  }
};

let __vrmState = {
  open: false,
  vendorKey: "",
  vendorName: "",
  vendorEmail: "",
  selected: 0,
  alreadyRated: false,
  userTouched: false, // ✅ NEW: user changed selection this open
};

function vrmEl(){ return document.getElementById('vendor-rating-modal'); }
function vrmOpen(){
  const m = vrmEl(); if (!m) return;
  m.classList.add('is-open');
  m.setAttribute('aria-hidden','false');
  document.body.classList.add('vrm-open');
}
function vrmClose(){
  const m = vrmEl(); if (!m) return;
  m.classList.remove('is-open');
  m.setAttribute('aria-hidden','true');
  document.body.classList.remove('vrm-open');
  __vrmState.open = false;
}

/* ===== Rating Modal helpers ===== */

function setRatingModalTier(modalEl, score){
  if (!modalEl) return;

  const s = Number(score);
 const tier =
  (!Number.isFinite(s) || s < 1.0) ? "unrated" :
  (s <= 5.9) ? "unrated" :     // 1.0–5.9 = BLACK
  (s <= 7.9) ? "bronze"  :
  (s <= 8.7) ? "silver"  :
  (s <= 9.4) ? "gold"    : "diamond";

  modalEl.classList.remove("is-bronze","is-silver","is-gold","is-diamond");
  if (tier) modalEl.classList.add("is-" + tier);
}

function paintUserSelectionInModal(score){
  const s = Number(score || 0);
  if (!(s >= 1 && s <= 10)) return;

  const m = vrmEl(); // ok if null

  const grid   = document.getElementById('vrm-stars');
  const submit = document.getElementById('vrm-submit');
  const hint   = document.getElementById('vrm-hint');

  __vrmState.selected = s;

  // tier glow on modal
  try { if (m) setRatingModalTier(m, s); } catch {}

  // highlight selected star
  if (grid){
    grid.querySelectorAll('.vrm-star').forEach(btn => {
      btn.classList.toggle('is-selected', Number(btn.dataset.value) === s);
    });
  }

  if (submit) submit.disabled = false;

  if (hint){
    hint.textContent = `Tu calificación: ${s}/10`;
  }

  // hot cache (5 min)
  try{
    const ck = userRatingCacheKey(__vrmState.vendorKey, __vrmState.vendorEmail || "");
    USER_RATING_CACHE.set(ck, { score: s, ts: Date.now() });
  }catch{}
}

/* Public: called from your banner star click */
function openVendorRatingModal({ vendorKey, vendorName, vendorEmail }){
  const ratingKey = getRatingVendorKey(vendorKey, vendorEmail);
  __vrmState = { open:true, vendorKey: ratingKey, vendorName, vendorEmail, selected:0, alreadyRated:false };

  const m = vrmEl(); // ok if null

  setRatingModalTier(m, __vrmState.selected || 0);

  const nameEl = document.getElementById('vrm-vendor-name');
  const grid   = document.getElementById('vrm-stars');
  const submit = document.getElementById('vrm-submit');
  const hint   = document.getElementById('vrm-hint');

  if (nameEl) nameEl.textContent = vendorName || vendorKey || "Vendedor";
  if (hint) hint.textContent = "Selecciona una calificación (1–10).";
  if (submit) submit.disabled = true;
  setRatingModalTier(m, 0);

  // build 10 star options
  if (grid){
    grid.innerHTML = "";
    for (let i=1; i<=10; i++){
      const b = document.createElement('button');
      b.type = "button";
      b.className = "vrm-star";
      b.dataset.value = String(i);
      b.innerHTML = `<span class="n">${i}</span>`;
      b.addEventListener('click', () => {
  __vrmState.userTouched = true; // ✅ NEW
  __vrmState.selected = i;
  setRatingModalTier(m, i);
  grid.querySelectorAll('.vrm-star').forEach(x => x.classList.toggle('is-selected', x === b));
  if (submit) submit.disabled = false;
  if (hint) hint.textContent = `Tu calificación: ${i}/10`;
});
      grid.appendChild(b);
    } 
  }

  // ✅ INSTANT: paint from cache/local BEFORE any network
  try{
    const ck = userRatingCacheKey(__vrmState.vendorKey, __vrmState.vendorEmail || "");
    const cached = USER_RATING_CACHE.get(ck);
    const local  = getUserRatingLocalFast(__vrmState.vendorKey, __vrmState.vendorEmail || "");
    const fastScore = (cached && (Date.now() - cached.ts) < 5 * 60_000)
      ? Number(cached.score || 0)
      : local;
    if (fastScore) paintUserSelectionInModal(fastScore);
  }catch{}

    // close handlers
  m.querySelectorAll('[data-vrm-close]').forEach(x=>{
    if (x.__vrmBound) return;
    x.__vrmBound = true;
    x.addEventListener('click', (e)=>{ e.preventDefault(); vrmClose(); });
  });

  // ✅ Click outside panel closes (but clicks INSIDE panel do not)
  if (!m.__vrmOutsideBound){
    m.__vrmOutsideBound = true;
    m.addEventListener('mousedown', (e) => {
      // only when modal is open
      if (!m.classList.contains('is-open')) return;

      const panel = m.querySelector('.vrm__panel');
      if (panel && !panel.contains(e.target)) {
        e.preventDefault();
        vrmClose();
      }
    });
  }

  // ESC closes
  if (!m.__vrmEsc){
    m.__vrmEsc = true;
    document.addEventListener('keydown', (e)=>{
      if (e.key === 'Escape' && vrmEl()?.classList.contains('is-open')) vrmClose();
    });
  }

  // check already rated (server first, then local)
  checkAlreadyRated(__vrmState.vendorKey, __vrmState.vendorEmail || "")
  .then(async ({ alreadyRated, score }) => {
    __vrmState.alreadyRated = !!alreadyRated;

    // --- fetch avg/count and keep it as a prefix ---
    let avgPrefix = "";
    try {
      const vk = __vrmState.vendorKey;
      const ve = canonicalizeEmail(__vrmState.vendorEmail || "") || vk;

      const r = await fetch(VENDOR_RATING.summaryUrl(vk, ve), { headers: { Accept: "application/json" } });
      if (r.ok) {
        const j = await r.json();
        const avg = Number(j?.vendorRatingAvg ?? j?.vendorRating);
        const cnt = Number(j?.vendorRatingCount);

        if (Number.isFinite(cnt)) {
          const text = cnt > 0 && Number.isFinite(avg) ? `${avg.toFixed(1)} (${cnt})` : `0.0 (0)`;
          avgPrefix = `Promedio del vendedor: ${text}. `;
        }
      }
    } catch {}

    const existing = Number(score || 0);
    if (existing >= 1 && existing <= 10) {
  if (!__vrmState.userTouched) { // ✅ NEW guard
    __vrmState.selected = existing;

    grid?.querySelectorAll(".vrm-star").forEach((btn) => {
      btn.classList.toggle("is-selected", Number(btn.dataset.value) === existing);
    });

    if (submit) submit.disabled = false;
  }

  // hint can still show current rating, even if user touched
  if (hint) hint.textContent =
    `${avgPrefix}Tu calificación actual: ${existing}/10 (puedes cambiarla)`.trim();
}
 else {
      if (hint) hint.textContent = `${avgPrefix}Selecciona una calificación (1–10).`.trim();
    }
  });

  // submit handler (bind once)
  if (submit && !submit.__vrmSubmitBound){
    submit.__vrmSubmitBound = true;
    submit.addEventListener('click', async () => {

      const score = Number(__vrmState.selected || 0);
      if (!(score >= 1 && score <= 10)) return;

      submit.disabled = true;
      if (hint) hint.textContent = "Enviando...";

      try {
  // Submit (server)
  await submitVendorRatingServer(
    __vrmState.vendorKey,
    score,
    __vrmState.vendorEmail,
    __vrmState.vendorName
  );
  __vrmState.alreadyRated = true;
  if (hint) hint.textContent = "¡Gracias! ✅";

  // ✅ Refresh using canonical vendor key (prefer email identity)
  await refreshVendorAverageIntoBanner(__vrmState.vendorKey, __vrmState.vendorEmail || "");
  setTimeout(vrmClose, 650);
} catch (err) {
        // local fallback
        try{
          submitVendorRatingLocal(__vrmState.vendorKey, score);
          __vrmState.alreadyRated = true;
          if (hint) hint.textContent = "Guardado ✅ (local)";
          refreshVendorAverageIntoBannerLocal(__vrmState.vendorKey);
          setTimeout(vrmClose, 650);
        }catch(e2){
          if (hint) hint.textContent = "Error al guardar. Intenta de nuevo.";
          submit.disabled = false;
        }
      }
    });
  }

  vrmOpen();
}

/* -------- checks -------- */
async function checkAlreadyRated(vendorKey, vendorEmail=""){
  vendorKey = getRatingVendorKey(vendorKey, vendorEmail);
  const uid = VENDOR_RATING.userId();

  try{
    const r = await fetch(VENDOR_RATING.alreadyUrl(vendorKey, vendorEmail, uid), {
      headers:{Accept:"application/json"}
    });
    
    if (r.ok){
  const j = await r.json();
  const alreadyRated = !!j?.alreadyRated;
  const score = Number(j?.score || 0);

  if (alreadyRated && score){
  // ✅ Only paint if user hasn't changed selection since open
  if (!__vrmState.userTouched) {
    paintUserSelectionInModal(score);
  }

    // 🔥 WRITE-THROUGH CACHE (THIS IS THE LINE YOU ASKED FOR)
    try{
      const ck = userRatingCacheKey(vendorKey, vendorEmail || "");
      USER_RATING_CACHE.set(ck, { score, ts: Date.now() });
    }catch{}
  }

  return { alreadyRated, score };
}

  }catch{}

  // local
  try{
    const raw = localStorage.getItem(VENDOR_RATING.localKey(vendorKey));
    if (!raw) return { alreadyRated:false, score:0 };
    const j = JSON.parse(raw);
    const s = Number(j?.byUser?.[uid] || 0);
    return { alreadyRated: !!(j?.byUser?.[uid]), score: s };
  }catch{
    return { alreadyRated:false, score:0 };
  }
}

/* -------- server submit (recommended) -------- */
async function submitVendorRatingServer(vendorKey, score10, vendorEmail = "", vendorName = "") {
  const canonicalVendorKey = getRatingVendorKey(vendorKey, vendorEmail);
  const canonEmail = canonicalizeEmail(vendorEmail || "") || canonicalVendorKey;
  const payload = {
    vendorKey: canonicalVendorKey,
    vendorEmail: canonEmail || canonicalVendorKey, // keep consistent
    vendorName: String(vendorName || "").trim(),   // helps when creating profile
    userId: VENDOR_RATING.userId(),
    score: Number(score10),
  };

  const r = await fetch(VENDOR_RATING.submitUrl(), {
    method: "POST",
    headers: { "Content-Type": "application/json", "Accept": "application/json" },
    body: JSON.stringify(payload),
  });

  let j = null;
  try { j = await r.json(); } catch {}

  if (!r.ok) throw new Error(j?.message || j?.error || r.statusText);
  return j;
}


/* -------- server summary -> update banner -------- */
async function refreshVendorAverageIntoBanner(vendorKey, vendorEmail = "") {
  vendorKey   = getRatingVendorKey(vendorKey, vendorEmail);
  vendorEmail = canonicalizeEmail(vendorEmail || "") || vendorKey;
  if (!vendorKey) return;

  const sel = `.vendor-button[data-vendor-key="${CSS.escape(vendorKey)}"] .vendor-rating-cta .score`;

  const pickCount = (j) => {
    // tolerate different backend field names
    const raw =
      j?.vendor_rating_count ??
      j?.vendorRatingCount ??
      j?.numRaters ??
      j?.raters ??
      j?.count ??
      j?.votes ??
      j?.totalRaters ??
      j?.vendorRatingNumRaters;

    const n = Number(raw);
    return Number.isFinite(n) ? n : NaN;
  };

  const pickAvg = (j) => {
    const n = Number(j?.vendor_rating ?? j?.vendorRatingAvg ?? j?.vendorRating);
    return Number.isFinite(n) ? n : NaN;
  };

  const paint = (avg, count) => {
  const _doPaint = () => {
    const hasCount = Number.isFinite(count);
    const hasAvg   = Number.isFinite(avg);
    const text =
      hasCount && count > 0 && hasAvg ? avg.toFixed(1) :
      (hasCount && count === 0 ? "0.0" : "—");

    const els = document.querySelectorAll(sel);

    // Retry once if elements not in DOM yet (race vs renderAllVendors)
    if (!els.length) {
      setTimeout(() => {
        document.querySelectorAll(sel).forEach(el => { el.textContent = text; });
        if (hasCount) {
          if (count <= 0) applyTierClassToCtas(vendorKey, "unrated");
          else if (hasAvg) applyTierClassToCtas(vendorKey, ratingTierFromSummary(avg, count));
        }
      }, 400);
      return;
    }

    els.forEach(el => { el.textContent = text; });
    if (hasCount) {
      if (count <= 0) applyTierClassToCtas(vendorKey, "unrated");
      else if (hasAvg) applyTierClassToCtas(vendorKey, ratingTierFromSummary(avg, count));
    }
  };
  Sched.raf(_doPaint);
};

  try {
    const now = Date.now();
    const cached = VENDOR_RATING_AVG_CACHE.get(vendorKey);

    // ✅ cache hit
    if (cached && (now - cached.ts) < 60_000) {
  // paint immediately, but the paint fn now handles DOM-not-ready internally
  paint(Number(cached.avg), Number(cached.count));
  // also schedule a repaint after renderAllVendors may have finished
  if (!document.querySelectorAll(sel).length) {
    setTimeout(() => paint(Number(cached.avg), Number(cached.count)), 300);
  }
  return;
}

    // ✅ de-dupe inflight
    if (VENDOR_RATING_AVG_INFLIGHT.has(vendorKey)) {
  try {
    const result = await VENDOR_RATING_AVG_INFLIGHT.get(vendorKey);
    if (result && Number.isFinite(result.count)) {
      paint(Number(result.avg), Number(result.count));
    }
  } catch {}
  return;
}

  const p = (async () => {
  const qs = new URLSearchParams({
    vendorKey,
    vendorEmail,
    v: String(Date.now()), // bust edge caches
  });

  const r = await fetch(`${apiUrl("vendor-rating/summary")}?${qs.toString()}`, {
    headers: { Accept: "application/json" },
    cache: "no-store",
    mode: "cors",
  });
  if (!r.ok) return;

  const j = await r.json();

  const avg   = pickAvg(j);
  const count = pickCount(j);

  // if avg is missing but count is 0, still valid (show 0.0)
  if (!Number.isFinite(count)) return;
  if (count > 0 && !Number.isFinite(avg)) return;

  const safeAvg = Number.isFinite(avg) ? avg : 0;

  // ✅ cache first
  VENDOR_RATING_AVG_CACHE.set(vendorKey, { avg: safeAvg, count, ts: Date.now() });

  // ✅ paint
  paint(safeAvg, count);

  // ✅ IMPORTANT: return something so inflight waiters can use it if needed
  return { avg: safeAvg, count };
})();

VENDOR_RATING_AVG_INFLIGHT.set(vendorKey, p);
await p;
} catch {
  // ignore
} finally {
  VENDOR_RATING_AVG_INFLIGHT.delete(vendorKey);
}

}

/* -------- local fallback storage -------- */
function submitVendorRatingLocal(vendorKey, score10){
  const uid = VENDOR_RATING.userId();
  const key = VENDOR_RATING.localKey(vendorKey);

  let j = { totalScore:0, numRaters:0, byUser:{} };
  try{ j = JSON.parse(localStorage.getItem(key) || "") || j; }catch{}

  j.byUser = j.byUser || {};

  const next = Number(score10);
  const prev = Number(j.byUser[uid] || 0);
  const hadPrev = (prev >= 1 && prev <= 10);

  // write new score
  j.byUser[uid] = next;

  if (hadPrev) {
    // update total without changing raters count
    j.totalScore = Number(j.totalScore || 0) - prev + next;
    j.numRaters  = Number(j.numRaters  || 0) || 1;
  } else {
    j.totalScore = Number(j.totalScore || 0) + next;
    j.numRaters  = Number(j.numRaters  || 0) + 1;
  }

  localStorage.setItem(key, JSON.stringify(j));
}

function refreshVendorAverageIntoBannerLocal(vendorKey){
  vendorKey = getRatingVendorKey(vendorKey, "");
  const key = VENDOR_RATING.localKey(vendorKey);

  try{
    const j = JSON.parse(localStorage.getItem(key) || "");
    const totalScore = Number(j?.totalScore || 0);
    const numRaters  = Number(j?.numRaters  || 0);

    // if no ratings
    if (!numRaters){
      document
        .querySelectorAll(`.vendor-button[data-vendor-key="${CSS.escape(vendorKey)}"] .vendor-rating-cta .score`)
        .forEach(el => el.textContent = "—");
      applyTierClassToCtas(vendorKey, "unrated");
      return;
    }

    const avg = totalScore / numRaters; // ✅ avg defined before used
    document
      .querySelectorAll(`.vendor-button[data-vendor-key="${CSS.escape(vendorKey)}"] .vendor-rating-cta .score`)
      .forEach(el => el.textContent = avg.toFixed(1));

    const tier = ratingTierFromSummary(avg, numRaters);
    applyTierClassToCtas(vendorKey, tier);

  }catch{
    // ignore
  }
}


function sanitizeForFilename(s = "") {
  return String(s).toLowerCase().replace(/[^a-z0-9._@-]+/g, "-").replace(/-+/g, "-").replace(/^-|-$/g, "");
}
function getExtFromFile(file){
  const t=(file?.type||"").toLowerCase();
  if (t.includes("png")) return "png";
  if (t.includes("webp")) return "webp";
  if (t.includes("jpeg")||t.includes("jpg")) return "jpg";
  const n=(file?.name||"").toLowerCase();
  const m=n.match(/\.(png|webp|jpe?g)$/i);
  return m ? m[1].toLowerCase().replace("jpeg","jpg") : "";
}
function readFileAsBase64(file){
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => {
      const s = String(r.result || "");
      const i = s.indexOf("base64,");
      resolve(i >= 0 ? s.slice(i + 7) : s);
    };
    r.onerror = () => reject(r.error || new Error("readAsDataURL failed"));
    r.readAsDataURL(file);
  });
}
function isMobileViewport(){ const w = window.visualViewport?.width || window.innerWidth || document.documentElement.clientWidth; return w < 768; }
function getResponsiveGridSize(){ const w=window.innerWidth; if (w<380) return 1; if (w<500) return 2; if (w<768) return 3; return 3; }
function sizedShopifyImage(url, targetW){
  if (!url || typeof url!=="string" || !url.includes("cdn.shopify.com")) return url;
  const w=Math.min(Math.max(parseInt(targetW||400,10)||400,100),1200);
  const m=url.match(/^(.*\/[^.?]+)(\.(?:jpe?g|png|webp))(?:\?(.*))?$/i);
  if (!m) return url;
  const [, b, ext, q] = m;
  return `${b}_${w}x${ext}${q ? `?${q}` : ""}`;
}
function buildSrcset(url){
  const widths = [180,240,300,360,480,600,720,900,1080,1200];
  return widths.map(w => `${sizedShopifyImage(url,w)} ${w}w`).join(', ');
}
const _binderDebounce = (fn, ms=200) => { let t; return (...a)=>{ clearTimeout(t); t=setTimeout(()=>fn(...a), ms); }; };
function normalizeVariantId(v){
  if (v==null) return null;
  const m=String(v).match(/(\d{8,})$/);
  return m ? m[1] : null;
}
function handleFromUrl(u=""){
  const m=String(u).match(/\/products\/([^\/?#]+)/i);
  return m?decodeURIComponent(m[1]):"";
}

/* Guard: enforce absolute API base */
function getApiBaseOrThrow(){
  const base = (window.__BINDER_API_BASE || (typeof API_BASE!=='undefined' ? API_BASE : '') || '').trim();
  if (!/^https?:\/\//i.test(base)) {
    throw new Error('API_BASE inválido. Configura la URL completa (https://…/api) en la sección.');
  }
  return base.replace(/\/+$/,'');
}
function apiUrl(path = '') {
  const b = getApiBaseOrThrow();
  return `${b}${path.startsWith('/') ? '' : '/'}${path}`;
}

/* Keeps bottom toolbar from overlapping content on mobile */
function updateMobileToolbarInset(){
  try{
    const bc = document.getElementById('binder-content');
    const bar = bc?.querySelector('.layout-selector');
    const h = bar ? Math.round(bar.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--mobile-toolbar-h', h + 'px');
  } catch {}
}
function hookToolbarResizeOnce(){
  try{
    if (!('ResizeObserver' in window)) return;
    const host = document.getElementById('binder-content');
    const bar = host?.querySelector('.layout-selector');
    if (!bar || bar.__ro) return;
    const ro = new ResizeObserver(()=> Sched.raf(updateMobileToolbarInset));
    ro.observe(bar);
    bar.__ro = true;
  }catch{}
}

/* Simple horizontal swipe pager for modal */
function enableSwipePaging(root, onPrev, onNext){
  const el = root || document.getElementById('binder-content');
  if (!el || el.__swipeBound) return;
  el.__swipeBound = true;
  let x0=null, y0=null, t0=0;
  el.addEventListener('touchstart', e => {
    const t = e.touches?.[0]; x0=t?.clientX; y0=t?.clientY; t0=Date.now();
  }, { passive:true });
  el.addEventListener('touchend', e => {
    if (x0==null) return;
    const t = e.changedTouches?.[0];
    const dx = t.clientX - x0, dy = t.clientY - y0, dt = Date.now() - t0;
    x0 = y0 = null;
    if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy)*1.5 && dt < 600){
      if (dx > 0) onPrev && onPrev(); else onNext && onNext();
    }
  }, { passive:true });
}

/* ===== Inventory fetch (batched + cached) ===== */
function buildAllForms(ids=[]){
  const out=new Set();
  ids.forEach(v=>{
    const n=(String(v).match(/(\d{8,})$/)||[])[1];
    if (n){
      out.add(n);
      out.add(`gid://shopify/ProductVariant/${n}`);
    }
  });
  return [...out];
}
async function fetchInventoryMap(variantIds = []) {
  if (!variantIds.length) return {};
  const out = {};
  const miss = [];
  for (const id of variantIds){
    if (INV_CACHE.has(id)) out[id] = INV_CACHE.get(id);
    else miss.push(id);
  }
  if (!miss.length) return out;

  const forms = buildAllForms(miss);
  const payload = { variantIds: forms, ids: forms, variant_ids: forms };

  for (const url of INVENTORY_ENDPOINT_CANDIDATES()) {
    try {
      const res = await fetch(url, {
        method:"POST",
        headers:{ "Content-Type":"application/json", "Accept":"application/json" },
        body: JSON.stringify(payload)
      });
      let data = null; try { data = await res.json(); } catch {}
      if (!res.ok) throw new Error((data && (data.error || data.message)) || res.statusText);

      const normalizeObj = (obj) => Object.keys(obj||{}).reduce((acc,k)=>{
        const id = normalizeVariantId(k);
        const q = Number(obj[k]);
        if (id && Number.isFinite(q)) acc[id]=q;
        return acc;
      }, {});
      let fresh = {};
      if (Array.isArray(data)){
        fresh = data.reduce((acc, it)=>{
          const id = normalizeVariantId(it.variantId || it.id);
          const q = Number(it.quantity ?? it.qty ?? it.inventory ?? it.inventoryQuantity);
          if (id && Number.isFinite(q)) acc[id]=q;
          return acc;
        },{});
      } else if (data && typeof data==="object"){
        if (data.inventory && typeof data.inventory==="object") fresh = normalizeObj(data.inventory);
        else fresh = normalizeObj(data);
      }

      Object.entries(fresh).forEach(([k,v]) => cacheSetWithCap(INV_CACHE, k, v, 1200));
      return { ...out, ...fresh };
    } catch(e){}
  }

  return out;
}

/* ===== Slab fit + fallbacks ===== */
const SLAB_TUNING = {
  default:{topSafe:0,badgeFudge:6,inset:1},
  1:{topSafe:2,badgeFudge:10,inset:1},
  2:{topSafe:2,badgeFudge:8,inset:1},
  3:{topSafe:1,badgeFudge:6,inset:1},
  4:{topSafe:0,badgeFudge:4,inset:1},
  5:{topSafe:0,badgeFudge:2,inset:1}
};
function getGridSizeForFrame(frame){
  const ds=frame.getAttribute('data-gridsize')
    || frame.closest('.carousel-card')?.getAttribute('data-gridsize')
    || frame.closest('[class*="grid-"]')?.className.match(/grid-(1|2|3|4|5)\b/)?.[1];
  const n=parseInt(ds,10);
  return Number.isFinite(n)&&n>=1&&n<=10?n:3;
}
function fitSlabInFrame(frame) {
  const slab = frame.querySelector(':scope .slab');
  if (!slab) return;

  const isPreviewCard = !frame.closest('.grid-section') && !!frame.closest('.carousel-card');
  if (isPreviewCard) {
    frame.style.removeProperty('--slab-scale');
    slab.style.removeProperty('transform');
    slab.style.removeProperty('--slab-scale');
    return;
  }

  // Clear leftovers from the previous approach — width was blocked by
  // `width:100% !important` anyway; height was actively distorting the flex column.
  slab.style.removeProperty('width');
  slab.style.removeProperty('height');

  const retry = () => {
    if ((frame.__fitTries = (frame.__fitTries || 0) + 1) < 12) {
      requestAnimationFrame(() => fitSlabInFrame(frame));
    }
  };

  try {
    const cs = getComputedStyle(frame);
    const availW = frame.clientWidth  - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
    const availH = frame.clientHeight - parseFloat(cs.paddingTop)  - parseFloat(cs.paddingBottom);

    // offsetWidth/Height are layout values — transforms don't touch them.
    // .slab is width:100% of the frame; its height derives from
    // .slab-window's aspect-ratio:3/4, never from the frame height.
    const slabW = slab.offsetWidth;
    const slabH = slab.offsetHeight;

    const fitKey = `${Math.round(availW)}x${Math.round(availH)}|${Math.round(slabW)}x${Math.round(slabH)}`;
    if (frame.__fitKey === fitKey) return;
    if (availW <= 0 || availH <= 0 || slabW < 8 || slabH < 8) { retry(); return; }
    frame.__fitTries = 0;
    frame.__fitKey = fitKey;

    const gs = getGridSizeForFrame(frame);
    const T  = SLAB_TUNING[gs] || SLAB_TUNING.default;

    // .slab-badge is a normal-flow flex item — already inside slabH.
    // Reserving space for it a second time shrank and offset the slab.
    const reservedTopPx = 0;

    let scale = Math.min(availW / slabW, availH / slabH);
    if (!Number.isFinite(scale) || scale <= 0) scale = 1;
    scale = Math.max(Math.min(scale, 1) * 0.995, 0.05);

    frame.style.setProperty('--slab-inset', (T.inset ?? 1) + 'px');
    slab.style.setProperty('--slab-scale', String(scale));
    slab.style.setProperty('--slab-reserved', `${reservedTopPx}px`);

    const wimg = slab.querySelector(':scope .slab-window img');
    if (wimg && !wimg.complete && !wimg.__fitBound) {
      wimg.__fitBound = 1;
      wimg.addEventListener('load',  () => { frame.__fitKey = null; fitSlabInFrame(frame); }, { once: true });
      wimg.addEventListener('error', () => { frame.__fitKey = null; fitSlabInFrame(frame); }, { once: true });
    }

    slab.style.removeProperty('transform');
  } catch (e) {
    frame.__fitKey = null;
  }
}

function enforceSingleSlab(frame){
  if (!frame) return;
  frame.querySelectorAll(':scope > img:not(.slab-fallback-img), :scope > a > img, :scope > picture, :scope > a > picture').forEach(n=>n.remove());
  const slabs=frame.querySelectorAll(':scope > .slab');
  for (let i=1;i<slabs.length;i++) slabs[i].remove();
}
function applySlabFallbacks(frame) {
  const slab = frame.querySelector(":scope .slab");
  const badge = frame.querySelector(":scope .slab-fallback-badge");
  const fallbackImg = frame.querySelector(":scope .slab-fallback-img");

  // Not a slab frame — nothing to do
  if (!frame.classList.contains('uses-slab')) return;

  // If CardSlab JS hasn't run yet, the slab won't have been hydrated.
  // Wait for it instead of immediately marking broken.
  const isHydrated = slab && (
    slab.querySelector('.slab-window') ||
    slab.classList.length > 1 ||
    slab.childElementCount > 0
  );

  if (!isHydrated) {
    // Retry after a short delay — CardSlab may still be loading
    setTimeout(() => {
      try { enforceSingleSlab(frame); fitSlabInFrame(frame); applySlabFallbacks(frame); } catch {}
    }, 300);
    return;
  }

  // Safety net: if card-slab.js script is still loading, wait for it then refit
  if (!window.CardSlab) {
    const slabScript = document.querySelector('script[src*="card-slab.js"]');
    if (slabScript && !slabScript.__slabSafetyBound) {
      slabScript.__slabSafetyBound = true;
      slabScript.addEventListener('load', () => {
        setTimeout(() => {
          try { mountSlabs(document.getElementById('binder-content') || document); } catch {}
        }, 120);
      });
    }
    // Still retry this frame regardless
    setTimeout(() => {
      try { enforceSingleSlab(frame); fitSlabInFrame(frame); applySlabFallbacks(frame); } catch {}
    }, 500);
    return;
  }

if (frame.__slabOk) return;   // already judged good — don't re-litigate

  const fw = frame.clientWidth, fh = frame.clientHeight;
  if (fw < 4 || fh < 4) {
    setTimeout(() => applySlabFallbacks(frame), 250);
    return;
  }

  // offsetWidth/Height are transform-independent, so a correctly
  // scaled-down slab is never mistaken for a broken one.
  const sw = slab.offsetWidth, sh = slab.offsetHeight;
  const broken = !(sw > 10 && sh > 10);

  if (broken) {
    frame.classList.add("slab-bad");
    if (badge) badge.hidden = false;
    if (fallbackImg) fallbackImg.hidden = false;
  } else {
    frame.__slabOk = 1;
    frame.classList.remove("slab-bad");
    if (badge) badge.hidden = true;
    if (fallbackImg) fallbackImg.hidden = true;
  }
}


/* Visible observer for frames (slab + inventory only when needed) */
const FrameIO = new IntersectionObserver((entries)=>{
  for (const e of entries){
    if (!e.isIntersecting) continue;
    const frame = e.target;
    // Refresh only this visible frame (fast)
   refreshInventoryForFrames([frame]);

    if (!SEEN_FRAME.has(frame)){
      SEEN_FRAME.add(frame);
      if (frame.classList.contains('uses-slab')){
        Sched.raf(() => { enforceSingleSlab(frame); fitSlabInFrame(frame); applySlabFallbacks(frame); });
      }
      Sched.idle(() => refreshInventoryForFrames([frame]), 60);
    } else {
      if (frame.classList.contains('uses-slab')) Sched.raf(() => fitSlabInFrame(frame));
    }
  }
}, { root:null, rootMargin:'300px 0px', threshold:0.01 });

const FrameRO = ('ResizeObserver' in window)
  ? new ResizeObserver((entries)=>{
      for (const entry of entries){
        const frame = entry.target;
        if (frame.classList.contains('uses-slab')){
          // Frame box actually changed — allow one re-fit.
          // __slabNat stays frozen: the image's intrinsic size never changes.
          frame.__fitKey = null;
          Sched.raf(()=> fitSlabInFrame(frame));
        }
      }
    })
  : null;

function mountSlabs(root=document){
  const el = (root && root.nodeType===1) ? root : document.body;

  try { if (typeof window.__hydrateSlabs === 'function') window.__hydrateSlabs(el); } catch {}
  try { document.dispatchEvent(new CustomEvent("card-slab:scan",{detail:{root:el}})); } catch {}

  el.querySelectorAll('.image-wrapper.product-image-wrapper').forEach((frame)=>{
    if (!frame.__obs){ FrameIO.observe(frame); frame.__obs=true; }
    if (FrameRO && frame.classList.contains('uses-slab') && !frame.__ro){
      FrameRO.observe(frame);
      frame.__ro = true;
    }
  });

  // First pass — fit immediately after paint
  Sched.raf(() => {
    el.querySelectorAll('.image-wrapper.product-image-wrapper.uses-slab').forEach(f => {
      try { enforceSingleSlab(f); fitSlabInFrame(f); } catch {}
      // Delay fallback check — don't judge before CardSlab has hydrated
      setTimeout(() => { try { applySlabFallbacks(f); } catch {} }, 400);
    });
  });

  // Retry passes — CardSlab JS may still be executing on first mount
  [250, 600, 1200, 2200].forEach(ms => {
    setTimeout(() => {
      el.querySelectorAll('.image-wrapper.product-image-wrapper.uses-slab').forEach(f => {
        try { enforceSingleSlab(f); fitSlabInFrame(f); applySlabFallbacks(f); } catch {}
      });
    }, ms);
  });
}
/* ===== Mapping & resolving ===== */
function mapBackendToCard(p){
  const v = p?.variant || (Array.isArray(p?.variants) && p.variants[0]) || {};
  const handle = p?.handle || handleFromUrl(p?.url || p?.productUrl || p?.permalink || p?.href || "");
  function toNumericVariantId(val){
    const s=String(val||"");
    if (/^gid:\/\/shopify\/ProductVariant\//i.test(s)) return (s.match(/(\d+)$/)||[])[1]||null;
    if (/^gid:\/\/shopify\/Product\//i.test(s)) return null;
    const m=s.match(/(\d{8,})$/);
    return m?m[1]:null;
  }
  const candidates=[ v.admin_graphql_api_id, p.admin_graphql_api_id, v.id, p.variantId, p.variant_id ].filter(Boolean);
  let variantId=null;
  for (const c of candidates){ variantId = toNumericVariantId(c); if (variantId) break; }

  const tags = Array.isArray(p?.tags)
    ? p.tags.filter(Boolean)
    : String(p?.tags||"").split(",").map(t=>t.trim()).filter(Boolean);

  const image = p?.image || v?.image || (Array.isArray(p?.images) && (p.images[0]?.src || p.images[0]?.url)) || "";
  const priceRaw = v?.priceAmount ?? v?.price ?? p?.price;
  const price = Number.isFinite(Number(priceRaw)) ? Number(priceRaw) : 0;

  const qtyRaw = v?.inventoryQuantity ?? p?.inventoryQuantity;
  const quantity = Number.isFinite(Number(qtyRaw)) ? Number(qtyRaw) : undefined;

  return {
    gid:p?.gid||p?.admin_graphql_api_id||null,
    title:p?.title||"",
    handle,
    url: handle?`/products/${handle}`:(p?.url||p?.productUrl||""),
    image,
    price,
    quantity,
    tags,
    variantId,
    sku:v?.sku||p?.sku||"",
    binderPage:Number(p?.binderPage||0)||null,
    binderSlot:Number(p?.binderSlot||0)||null
  };
}

async function fetchBinderProductsForEmail(email){
  const canon = canonicalizeEmail(email);
  const url = `${BINDER_LIST_URL()}?email=${encodeURIComponent(canon)}`;
  const res = await fetch(url, { headers:{Accept:"application/json"} });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const json = await res.json();
  const arr = Array.isArray(json.products)?json.products:[];
  let mapped = arr.map(mapBackendToCard);
  if (!mapped.some(p => Number(p?.binderPage))) mapped.sort(byBinderThenTitle);
  return mapped;
}

async function resolveVariantIdFromHandle(handle, { preferSku } = {}) {
  if (!handle) return null;
  const cacheKey = preferSku
  ? `${handle}|sku:${String(preferSku).toLowerCase()}`
  : handle;
  if (VARIANT_RESOLVE_CACHE.has(cacheKey)) return VARIANT_RESOLVE_CACHE.get(cacheKey);

  try {
    if (PROD_CACHE.has(handle)) {
      const product = PROD_CACHE.get(handle);
      const id = pickVariantIdFromProduct(product, preferSku);
      cacheSetWithCap(VARIANT_RESOLVE_CACHE, cacheKey, id, 600);
      return id;
    }
    const res = await fetch(`/products/${handle}.js`, { headers:{ "Accept":"application/json" } });
    if (!res.ok) return null;
    const product = await res.json();
    cacheSetWithCap(PROD_CACHE, handle, product, 200);

    const id = pickVariantIdFromProduct(product, preferSku);
    cacheSetWithCap(VARIANT_RESOLVE_CACHE, cacheKey, id, 600);
    return id;
  } catch { return null; }
}
function pickVariantIdFromProduct(product, preferSku){
  if (!product?.variants?.length) return null;
  if (preferSku) {
    const bySku = product.variants.find(v => (v.sku||"").toLowerCase() === String(preferSku).toLowerCase());
    if (bySku) return String(bySku.id);
  }
  const firstAvailable = product.variants.find(v => v.available);
  return String((firstAvailable || product.variants[0]).id);
}

async function addVariantToCart(variantId, qty=1){
  const res = await fetch("/cart/add.js",{
    method:"POST",
    headers:{ "Content-Type":"application/json","Accept":"application/json"},
    body: JSON.stringify({ id:String(variantId), quantity:qty })
  });
  let data=null; try{ data=await res.json(); }catch{}
  if (!res.ok){
    const reason=(data&&(data.description||data.message))||res.statusText||"Add failed";
    const err=new Error(reason); err.response=data; throw err;
  }
  return data;
}

/* ===== Cart button wiring ===== */
function wireCartButton(btn){
  if (!btn || btn.__wired) return;
  btn.__wired = true;
  btn.addEventListener("click", async (e) => {
    e.preventDefault(); e.stopPropagation();
    if (btn.dataset.busy === "1") return;

    const handle = btn.dataset.handle || "";
    const sku    = btn.dataset.sku || "";
    let variantId = normalizeVariantId(btn.dataset.variantId);

    const setState = (state) => {
      btn.classList.remove("added", "error", "is-busy");
      if (state === "busy") {
    btn.classList.add("is-busy");
    btn.setAttribute("aria-busy","true");
    btn.dataset.busy="1";
    return;
  }
  // for added/error/idle we always clear busy flags
  btn.removeAttribute("aria-busy");
  delete btn.dataset.busy;
  if (state === "added") { btn.classList.add("added"); btn.innerHTML="✅"; }
  else if (state === "error") { btn.classList.add("error"); btn.innerHTML="🚫"; }
  else { btn.innerHTML="➕"; }

    };
    const finish = (ms=2000)=> setTimeout(()=> setState("idle"), ms);
    const addOnce = async(id)=>{ if (!id) throw new Error("Missing variant id"); await addVariantToCart(id,1); return id; };

    setState("busy");
    try {
      if (!variantId) variantId = await resolveVariantIdFromHandle(handle, { preferSku: sku });
      await addOnce(variantId);
      setState("added"); finish(2000);
    } catch (err) {
      try {
        const resolved = await resolveVariantIdFromHandle(handle, { preferSku: sku });
        if (resolved && resolved !== variantId) {
          await addOnce(resolved); setState("added"); finish(2000); return;
        }
        throw err;
      } catch (finalErr) {
        console.error("Add to cart failed:", finalErr?.response || finalErr?.message || finalErr);
        setState("error"); finish(3000);
      }
    }
  });
}

function ensureCartButtons(root=document){
  const scope = (root && root.nodeType === 1) ? root : document;
  scope.querySelectorAll('.image-wrapper.product-image-wrapper').forEach(frame => {
    const existing = frame.querySelector(':scope > .add-to-cart-btn');
    if (existing){
  if (!existing.__wired && existing.dataset.clickWired !== "1") {
    wireCartButton(existing);
    markWired(existing);
  }
  return;
}

    const a = frame.querySelector(':scope a[href*="/products/"]');
    const handleFromHref = a ? (a.getAttribute('href')||'').match(/\/products\/([^\/?#]+)/i)?.[1] : '';
    const handle = frame.dataset.handle || handleFromHref || '';
    const variantId = frame.dataset.variantId || '';
    const sku = frame.dataset.sku || '';
    if (!handle && !variantId) return;

    const btn = document.createElement('button');
    btn.className='add-to-cart-btn'; btn.innerHTML='➕'; btn.title='Agregar al carrito';
    btn.dataset.handle=handle||''; btn.dataset.variantId=variantId||''; btn.dataset.sku=sku||'';
    frame.appendChild(btn);
 wireCartButton(btn);
 markWired(btn);
  });
}
(function watchBinderForCartButtons(){
  const bc = document.getElementById('binder-content');
  if (!bc || bc.__watchingCartBtns) return;
  let t = null;
 const kick = () => {
   if (t) return;
   t = setTimeout(()=>{ t=null; ensureCartButtons(bc); }, 50);
 };
  const mo = new MutationObserver(kick);
  mo.observe(bc, { childList:true, subtree:true });
  bc.__watchingCartBtns = true;
})();

/* ===== Augmenting helpers ===== */
function vendorKeyFrom(name, email){
  if (email && String(email).trim()) {
    // ✅ Use the same canonical identity (gmail dot/plus normalization)
    const canon = canonicalizeEmail(email);
    return canon ? canon : String(email).trim().toLowerCase();
  }
  return String(name||'').toLowerCase()
    .normalize('NFKD').replace(/[\u0300-\u036f]/g,'')
    .replace(/\s+/g,'_').replace(/[^\w@.]/g,'');
}

function pickPrimaryVendorEmail(bucket, key){
  const candidates = [];

  // ✅ prefer explicit vendor email fields first
  candidates.push(bucket?.vendorEmail, bucket?.vendor_email, bucket?.email);

  // ✅ only consider key if it canonicalizes to an email (many keys are NOT emails)
  if (key) candidates.push(key);

  // ✅ try to extract from products if bucket email is grouped/dirty
  const prods = Array.isArray(bucket?.products) ? bucket.products : [];
  for (const p of prods){
    candidates.push(p?.vendorEmail, p?.vendor_email, p?.email, p?.vendor);
  }

  for (const raw of candidates){
    if (!raw) continue;

    const s = String(raw).trim();
    if (!s) continue;

    // if it's grouped, take the first token that canonicalizes
    const parts = s.split(/[,\s;|]+/g).map(x => x.trim()).filter(Boolean);
    for (const part of parts){
      const canon = canonicalizeEmail(part);
      if (canon) return canon;
    }

    // also allow a single clean email string
    const canonWhole = canonicalizeEmail(s);
    if (canonWhole) return canonWhole;
  }

  return ""; // unknown
}

function getVendorIdentityKey(bucket, key, fallbackName=""){
  const email = pickPrimaryVendorEmail(bucket, key);
  if (email) return email; // ✅ canonical email preferred

  // fallback stable string key (non-email)
  return String(bucket?.vendorKey || key || fallbackName || "")
    .trim()
    .toLowerCase();
}

/* Everything a vendor can be searched by: vendor name, STORE NAME
   (custom.user_store metafield — what the banner actually displays),
   last name, and profile values. */
function vendorSearchHaystack(bucket, key){
  let profile = null;
  try {
    const idKey = getVendorIdentityKey(bucket, key, bucket?.vendorName || "");
    profile = (window.VENDOR_PROFILES && window.VENDOR_PROFILES[idKey]) || null;
  } catch {}
  return [
    bucket?.vendorName,
    bucket?.userStore,          // ← store name from backend grouping
    bucket?.user_store,
    bucket?.vendorLastName,
    profile?.user_store,        // ← store name from vendor_profile metaobject
    profile?.vendor_name,
    key
  ].filter(Boolean).join(" ").toLowerCase();
}

function getInitialVendorHint(){
  try{
    const params = new URLSearchParams(window.location.search || '');

    // NEW: public slug — the only param we'll emit going forward
    const slug = storeSlug(params.get('store') || '');

    // LEGACY: email-based params, still accepted so old links keep working
    const legacyRaw =
      params.get('vendorKey')    ||
      params.get('vendor')       ||
      params.get('vendor_email') ||
      params.get('vendorEmail')  ||
      params.get('email')        || '';

    const fromGlobal  = window.NB_INITIAL_VENDOR || window.BINDER_VENDOR || '';
    const fromStorage =
      (sessionStorage.getItem('nb:activeVendor') ||
       sessionStorage.getItem('nb:lastVendor')   ||
       localStorage.getItem('nb:activeVendor')   ||
       localStorage.getItem('nb:lastVendor')) || '';

    return { slug, legacy: String(legacyRaw || fromGlobal || fromStorage || '').trim() };
  } catch {
    return { slug:'', legacy:'' };
  }
}


/* ===== Default vendor banner (when none assigned) ===== */
function getDefaultVendorBannerURL(){
  // Prefer a theme/global override if you set it in Liquid:
  // window.DEFAULT_VENDOR_BANNER_URL = "https://.../default.jpg"
  const g = (window.DEFAULT_VENDOR_BANNER_URL || "").trim();
  if (g) return g;

  // Fallback to a theme asset path (adjust filename as needed)
  return "https://cdn.shopify.com/s/files/1/0731/4128/9172/files/NENSONS_SHOPS.png?v=1770499898";
}

function appendCacheBust(url){
  const u = String(url || "").trim();
  if (!u) return "";
  // Use cb= (not v=) to avoid conflicting with Shopify's own ?v= version param
  return `${u}${u.includes('?') ? '&' : '?'}cb=${Date.now()}`;
}

// ===== Vendor banner in-memory cache (prevents blink on re-render) =====
const VendorBannerCache = (() => {
  const m = new Map(); // vendorKey -> { url, ok }
  return {
    get: (k) => m.get(String(k || "")),
    set: (k, v) => m.set(String(k || ""), v),
  };
})();

function applyVendorBanner(buttonEl, url, opts = {}){
  if (!buttonEl) return;

  const isReal = !!(url && String(url).trim());
  const finalUrl = isReal ? String(url).trim() : getDefaultVendorBannerURL();

  // Only cache-bust when explicitly requested (default false)
  const bust = opts.cacheBust ? appendCacheBust(finalUrl) : finalUrl;

  buttonEl.style.backgroundImage = `url("${String(bust).replace(/"/g, '%22')}")`;

  // Only mark has-logo when it’s a real vendor banner AND we intend it to be treated as such
  if (opts.forceHasLogo === true) {
    buttonEl.classList.add('has-logo');
  } else if (opts.forceHasLogo === false) {
    buttonEl.classList.remove('has-logo');
  } else {
    if (isReal) buttonEl.classList.add('has-logo');
    else buttonEl.classList.remove('has-logo');
  }
}

// Probe an image URL; resolves true only if it actually loads
function probeImageURL(url, timeoutMs = 4500){
  return new Promise((resolve) => {
    const u = String(url || "").trim();
    if (!u) return resolve(false);

    const img = new Image();
    let done = false;

    const finish = (ok) => {
      if (done) return;
      done = true;
      try { img.onload = img.onerror = null; } catch {}
      resolve(!!ok);
    };

    const t = setTimeout(() => finish(false), timeoutMs);

    img.onload = () => { clearTimeout(t); finish(true); };
    img.onerror = () => { clearTimeout(t); finish(false); };

    // Cache-bust the probe request without touching Shopify's ?v=
    img.src = appendCacheBust(u);
  });
}

// Apply vendor banner only if it loads; otherwise fallback to default
async function applyVendorBannerSafely(buttonEl, vendorUrl, token){
  if (!buttonEl) return;
  if (!buttonEl || !buttonEl.isConnected) return;

  // ignore stale async results (before doing any work)
  if (token && buttonEl.__bannerToken !== token) return;

  const u = String(vendorUrl || "").trim();
  if (!u) {
    // token may have changed since our first check
    if (token && buttonEl.__bannerToken !== token) return;
    applyVendorBanner(buttonEl, "", { forceHasLogo:false });
    return;
  }

  const ok = await probeImageURL(u);
  if (!buttonEl || !buttonEl.isConnected) return;

  // token may have changed while probing/loading
  if (token && buttonEl.__bannerToken !== token) return;

  if (ok) {
    // Apply real vendor banner (NO extra cache-bust on the actual style URL)
    if (token && buttonEl.__bannerToken !== token) return;
    applyVendorBanner(buttonEl, u, { forceHasLogo:true });
  } else {
    // Fallback hard if the URL is dead
    console.warn("Vendor banner URL failed to load; falling back to default:", u);
    if (token && buttonEl.__bannerToken !== token) return;
    applyVendorBanner(buttonEl, "", { forceHasLogo:false });
  }
}

async function fetchVendorLogoURL(vendorKey){
  const url = `${apiUrl('vendor-logo')}?vendorKey=${encodeURIComponent(vendorKey)}`;
  const res = await fetch(url,{ headers:{Accept:"application/json"} });
  if (res.status===404) return "";  // ← already there, just don't log
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const j = await res.json();
  return j.url||"";
}

/* ===== Vendor banner upload helpers ===== */
function showToast(message, kind='success'){
  let el = document.querySelector('.toast');
  if (!el){
    el = document.createElement('div');
    el.className = 'toast';
    document.body.appendChild(el);
  }
  el.textContent = message;
  el.classList.remove('success','error','show');
  el.classList.add(kind);
  requestAnimationFrame(()=> {
    el.classList.add('show');
    setTimeout(()=> el.classList.remove('show'), 1800);
  });
}
function canEditVendorBanner(vendorEmail){
  try{
    const params = new URLSearchParams(location.search);
    if (params.has('edit')) return true;
    const me = canonicalizeEmail(window.CURRENT_CUSTOMER_EMAIL||'');
    const ve = canonicalizeEmail(vendorEmail||'');
    return me && ve && me === ve;
  }catch{ return false; }
}
function pickImageFile(){
  return new Promise(resolve => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.onchange = () => resolve((input.files && input.files[0]) || null);
    input.click();
  });
}
async function uploadVendorBanner(vendorKey, file){
  const ext      = getExtFromFile(file) || "png";
  const safeName = file?.name || `vendor-banner-${sanitizeForFilename(vendorKey)}.${ext}`;
  const mimetype = (file?.type || "").toLowerCase() || (ext === "jpg" ? "image/jpeg" : `image/${ext}`);
  const base64   = await readFileAsBase64(file);

  const url = apiUrl("vendor-logo");
  const res = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json", "Accept": "application/json" },
    body: JSON.stringify({
      vendorKey,
      file: { filename: safeName, mimetype, data: base64 }
    }),
    cache: "no-store",
    mode: "cors",
  });

  if (res.redirected || (res.status >= 300 && res.status < 400)) {
    throw new Error(`Endpoint redirige (${res.status}). Revisa API_BASE (debe apuntar exacto a …/api).`);
  }
  const ct = (res.headers.get("content-type") || "").toLowerCase();
  if (ct.includes("text/html")) {
    throw new Error(`El endpoint devolvió HTML (API_BASE mal configurado). Usé: ${res.url}`);
  }

  let data = null; try { data = await res.json(); } catch {}
  if (!res.ok) {
    const msg = (data && (data.error || data.message)) || `HTTP ${res.status}`;
    throw new Error(msg);
  }

  const out = data?.url || "";
  if (!out) throw new Error("Respuesta sin URL");
  return out;
}
function repaintVendorBanner(buttonEl, url){
  if (!buttonEl) return;

  // ✅ invalidate any in-flight fetchVendorLogoURL() that could overwrite this update
  const token = `manual:${Date.now()}:${Math.random().toString(16).slice(2)}`;
  buttonEl.__bannerToken = token;

  const vendorKey =
   buttonEl?.dataset?.vendorKey ||  // ✅ canonical identity key
   buttonEl?.getAttribute?.('data-vendor-key') ||
   buttonEl?.dataset?.vendorKeyRaw ||
   "";

  // Update clicked one + any other instances, but only if the image loads
  const targets = vendorKey
    ? Array.from(document.querySelectorAll(`.vendor-button[data-vendor-key="${CSS.escape(vendorKey)}"]`))
    : [buttonEl];

  targets.forEach(btn => { btn.__bannerToken = token; });

  // Probe once, then apply to all
  probeImageURL(url).then(ok => {
    targets.forEach(btn => {
      if (btn.__bannerToken !== token) return;
      if (ok) applyVendorBanner(btn, url, { forceHasLogo:true });
      else applyVendorBanner(btn, "", { forceHasLogo:false });
    });
  });
}

async function pickAndUploadBanner(vendorKey, buttonEl){
  try{
    const file = await pickImageFile();
    if (!file) return;
    if (!/^image\/(png|jpe?g|webp)$/i.test(file.type)) {
      showToast('Tipo no permitido. Usa PNG/JPG/WEBP.', 'error'); return;
    }
    if (file.size > 2 * 1024 * 1024) {
      showToast('Archivo demasiado grande (máx 2MB).', 'error'); return;
    }
    showToast('Subiendo banner...', 'success');
    const url = await uploadVendorBanner(vendorKey, file);
    repaintVendorBanner(buttonEl, url);
    showToast('Banner actualizado ✅', 'success');
  }catch(err){
    console.error(err);
    const raw = String(err && err.message || err || 'Error');
    const clean = raw.replace(/<[^>]*>/g,' ').replace(/\s+/g,' ').trim().slice(0,180);
    showToast(`Error al subir el banner: ${clean}`, 'error');
  }
}

function byBinderThenTitle(a, b) {
  // Si no tienen posiciones, ordenar por título
  const aPage = Number(a?.binderPage || 0);
  const bPage = Number(b?.binderPage || 0);
  const aSlot = Number(a?.binderSlot || 0);
  const bSlot = Number(b?.binderSlot || 0);
  
  // Si ambos tienen páginas válidas, ordenar por página y slot
  if (aPage > 0 && bPage > 0) {
    if (aPage !== bPage) return aPage - bPage;
    if (aSlot !== bSlot) return aSlot - bSlot;
  }
  
  // Si solo uno tiene página, el que tiene página va primero
  if (aPage > 0 && bPage === 0) return -1;
  if (aPage === 0 && bPage > 0) return 1;
  
  // Si ninguno tiene página, ordenar por título
  const aTitle = (a?.title || "").toLowerCase();
  const bTitle = (b?.title || "").toLowerCase();
  return aTitle.localeCompare(bTitle);
}

/* ===== Slab classifier & card builder ===== */
function classifySlab(graderText, tagsArr = []) {
  const hay = `${String(graderText || "")} ${tagsArr.join(" ")}`.toLowerCase();
  const m = hay.match(/(^|\s)(\d{1,2}(?:\.\d)?)(\s|$)/);
  const grade = m ? parseFloat(m[2]) : NaN;
  const has = (re)=>re.test(hay); const classes=[];
  if (has(/\bpsa\b/)) classes.push("slab--psa");
  else if (has(/\bbgs\b/)){
    classes.push("slab--bgs");
    if (grade===10 && has(/black\s*label/)) classes.push("slab--bgs-blacklabel");
    else if (grade>=9.5) classes.push("slab--bgs-gold");
    else classes.push("slab--bgs-silver");
  }
  else if (has(/\bcgc\b/)){
    classes.push("slab--cgc");
    if (grade===10 && has(/\bpristine\b/)) classes.push("slab--cgc-pristine10");
    else classes.push("slab--cgc-silver");
  }
  else if (has(/\bsgc\b/)){
    classes.push("slab--sgc");
    if (grade===10 && has(/\bpristine\b/)) classes.push("slab--sgc-pristine10");
    else if (grade===10) classes.push("slab--sgc-gem10");
    else classes.push("slab--sgc-silver");
  }
  else if (has(/\bgradelat\b/)){
    classes.push("slab--gradelat");
    if (grade===10 && has(/\bgem\b/)) classes.push("slab--gradelat-10-gem");
  }
  else if (has(/\bvalue\s?up\b/)){
    classes.push("slab--valueup");
    if (grade===10) classes.push("slab--valueup-10");
  }
  else if (has(/\bgxi\b/)) classes.push("slab--gxi");
  else classes.push("slab--graded-unknown");
  return classes.join(" ");
}

function createProductCard(product, targetWidth=300, priority="auto", eager=false, fixedSize=false, vendorName=""){
  const card=document.createElement("div");
  card.className="carousel-card";

  // Only allow drag for vendor-owner or admin (same gate as banner edit)
  const allowDrag = (() => {
    try{
      const me = canonicalizeEmail(window.CURRENT_CUSTOMER_EMAIL || '');
      const admin = canonicalizeEmail('nensons612@gmail.com');
      if (me && me === admin) return true;
      const ve = window.activeVendor?.email || window.activeVendor?.vendorEmail || '';
      return canEditVendorBanner(ve);
    }catch{ return false; }
  })();
  card.draggable = !!allowDrag;

  const companySafe=(vendorName||window.activeVendor?.vendorName||"Vendor").trim();
  const tags = Array.isArray(product.tags)
    ? product.tags.flatMap(t=>String(t).split(",")).map(t=>String(t).trim().toLowerCase()).filter(Boolean)
    : String(product.tags||"").split(",").map(t=>t.trim().toLowerCase()).filter(Boolean);

  const haystack = `${product.title||""} ${tags.join(" ")}`.toLowerCase();
  const GRADER_REGEX = /\b(psa|bgs|cgc|sgc|gradelat|valueup|gxi|graded|slab|slabbed)\b/;

const isSlab = !!(
  product.isSlab === true ||
  product.slab   === true ||
  product.graded === true ||
  GRADER_REGEX.test(haystack)   // must match a real grading keyword
);
  const slabClasses = isSlab
    ? classifySlab(`${product.title||""}`, Array.isArray(product.tags)?product.tags:String(product.tags||"").split(","))
    : "";

  const dataTags = escHtml(
  (Array.isArray(product.tags)?product.tags:String(product.tags||"").split(","))
    .map(t=>String(t).trim()).filter(Boolean).join(",")
);

  if (product.gid) card.dataset.gid = product.gid;

  const imgUrl = sizedShopifyImage(product.image, targetWidth);
  const productHandle = product.handle || handleFromUrl(product.url || "");

  const candidateIds=[
    product.variantId, product.variant_id,
    product.variant?.admin_graphql_api_id,
    product.variant?.id, product.admin_graphql_api_id
  ].filter(Boolean);

  function extractSafeVariantId(cands){
    for (const c of cands){
      const s=String(c);
      if (/^gid:\/\/shopify\/ProductVariant\//i.test(s)) return (s.match(/\d+$/)||[])[0]||null;
    }
    for (const c of cands){
      const s=String(c);
      if (/^gid:\/\/shopify\/Product\//i.test(s)) continue;
      const n=(s.match(/(\d{8,})$/)||[])[1];
      if (n) return n;
    }
    return null;
  }
  const rawVariantId = extractSafeVariantId(candidateIds);
  const sku = product.sku || product.SKU || product.sku_code || "";

  const imgBlock = isSlab
    ? `<div class="slab ${slabClasses}" data-tags="${dataTags}">
         <div class="slab-label"></div><div class="slab-badge"></div>
         <div class="slab-window">
           <a href="${product.url}" draggable="false">
             <img
               src="${imgUrl}"
               srcset="${buildSrcset(product.image)}"
               sizes="${Math.ceil(targetWidth||300)}px"
               alt="${escHtml(product.title)}"

               draggable="false"
               ${eager ? 'loading="eager"' : 'loading="lazy"'}
               decoding="async"
               fetchpriority="${priority}">
           </a>
         </div>
         <img class="slab-fallback-img" src="${imgUrl}" alt="${escHtml(product.title)}"
 hidden>
         <span class="slab-fallback-badge" hidden>${companySafe}</span>
       </div>`
    : `<a href="${product.url}" draggable="false"
         style="text-decoration:none;color:inherit;display:flex;flex-direction:column;align-items:center;height:100%;position:relative;z-index:1">
         <img
           src="${imgUrl}"
           srcset="${buildSrcset(product.image)}"
           sizes="${Math.ceil(targetWidth||300)}px"
           alt="${escHtml(product.title)}"

           draggable="false"
           ${eager ? 'loading="eager"' : 'loading="lazy"'}
           decoding="async"
           fetchpriority="${priority}">
       </a>`;

  // Always show qty badge; value filled by refreshInventoryForFrames.
  const priceNum = Number(product.price ?? 0);
  const safePrice = Number.isFinite(priceNum) ? priceNum : 0;

  card.innerHTML = `
    <div class="image-wrapper product-image-wrapper ${isSlab ? 'uses-slab' : ''}"
  data-variant-id="${rawVariantId ?? ''}"
  data-handle="${productHandle || ''}"
  data-sku="${sku || ''}">
      ${imgBlock}
      <span class="price-badge">$${safePrice.toFixed(2)}</span>
      <span class="quantity-badge" data-live="1">—</span>

      <button class="add-to-cart-btn"
        data-origin="${product.__augmentedFrom ? 'augmented' : ''}"
        data-variant-id="${rawVariantId ?? ''}"
        data-handle="${productHandle || ''}"
        data-sku="${sku}"
        title="Agregar al carrito">➕</button>
    </div>
    <div class="product-title-container" style="margin-top:-2px"><h3>${escHtml(product.title)}</h3></div>
  `;

  const btn = card.querySelector(".add-to-cart-btn");

if (btn && !btn.__wired && btn.dataset.clickWired !== "1") {
  wireCartButton(btn);
  btn.dataset.clickWired = "1";
}

  const frame = card.querySelector('.product-image-wrapper');
  if (!frame.__obs) {
  FrameIO.observe(frame);
  frame.__obs = true;
}
if (FrameRO && frame.classList.contains('uses-slab') && !frame.__ro){
  FrameRO.observe(frame);
  frame.__ro = true;
}

  return card;
}

/* ===== Inventory retry scheduler ===== */
const InvRetry = (() => {
  const pend = new Set();
  let t = null;

  function schedule(frame, delay = 220){
    if (!frame) return;
    pend.add(frame);
    if (t) return;
    t = setTimeout(() => {
      t = null;
      const batch = Array.from(pend);
      pend.clear();
      try { refreshInventoryForFrames(batch); } catch {}
    }, delay);
  }

  return { schedule };
})();

/* ===== Visible-first inventory refresh ===== */
async function refreshInventoryForFrames(framesOrRoot){
  let frames = [];
  if (framesOrRoot instanceof Element){
   // If they passed a real frame wrapper, treat as single-frame.
   // Otherwise treat it as a root container and query frames inside.
   if (framesOrRoot.classList?.contains('image-wrapper')) frames = [framesOrRoot];
   else frames = Array.from(framesOrRoot.querySelectorAll(".image-wrapper.product-image-wrapper"));
 }
  else if (Array.isArray(framesOrRoot)) frames = framesOrRoot;
  else frames = Array.from((framesOrRoot||document).querySelectorAll(".image-wrapper.product-image-wrapper"));

  if (!frames.length) return;

  const cards = frames.map(wrap=>{
    const btn=wrap?.querySelector(':scope > .add-to-cart-btn') || wrap?.querySelector('.add-to-cart-btn');
    const badge=wrap?.querySelector(':scope > .quantity-badge');
    const raw=(btn?.dataset.variantId||"").trim();
    const numeric=(raw.match(/(\d{8,})$/)||[])[1]||null;

    let handle = btn?.dataset.handle || "";
    if (!handle){
      const a=wrap?.querySelector('a[href*="/products/"]');
      const m=a?.getAttribute("href")?.match(/\/products\/([^\/?#]+)/i);
      if (m) handle = m[1];
    }

    return { wrap, btn, badge, variantId:numeric, handle, sku:(btn?.dataset.sku||"").trim() };
  }).filter(c=>c.badge);

  const active = cards.filter(c=>{
   const b = c.badge;
   if (!b) return false;
   // keep refreshing unknowns; skip stable loaded numbers unless forced
   if (b.__loaded === true && !b.classList.contains('qty-unknown')) return false;
   return true;
 });
 if (!active.length) return;
  Sched.raf(()=>{ active.forEach(c=>{ const b=c.badge; if (!b.__loaded){ b.textContent="—";
b.classList.add('qty-unknown','is-loading'); }}); });

  await Promise.allSettled(active.map(async c=>{
    if (!c.variantId && c.handle){
      const id = await resolveVariantIdFromHandle(c.handle, { preferSku: c.sku });
      c.variantId = normalizeVariantId(id);
      if (c.btn && c.variantId) c.btn.dataset.variantId = c.variantId;
      if (c.wrap && c.variantId) c.wrap.dataset.variantId = c.variantId; // keep wrapper in sync
    }
  }));

  const ids = [...new Set(active.map(c=>c.variantId).filter(Boolean))];
  
  // If some cards still missing IDs, retry soon (usually resolves next pass)
 for (const c of active){
   if (!c.variantId) InvRetry.schedule(c.wrap, 260);
 }
  let invMap = {};
 try {
   invMap = await fetchInventoryMap(ids);
 } catch (e) {
   console.warn("Inventory fetch failed; will retry", e);
   // keep UI as unknown for now; retry soon for the affected frames
   cards.forEach(c => InvRetry.schedule(c.wrap, 480));
   invMap = {};
 }

  for (const c of active){
    const badge = c.badge; if (!badge) continue;
    const key = c.variantId;
    const v =
  (invMap && key in invMap)
    ? invMap[key]
    : (key ? INV_CACHE.get(String(key)) : undefined);
    const known = key && Number.isFinite(Number(v));
    const q = known ? Number(v) : NaN;
    badge.classList.remove("qty-zero","qty-low","qty-ok","qty-unknown","updated","is-loading");
    badge.removeAttribute("data-digits");

    if (!known){
  badge.textContent = "—";
  badge.classList.add("qty-unknown");
  // Don't lock forever; variantId may resolve later or fetch may retry.
  badge.__loaded = false;
  // If we *have* a variantId but didn't get a value, retry quickly (partial map / cache)
  if (key) InvRetry.schedule(c.wrap, 520);
  continue;
}

    badge.textContent=String(q); // ✅ keep model in sync for sorting
   try {
     const card = c.wrap.closest('.carousel-card');
     const handle = c.handle;
     // update in currentVendorProducts when possible
     const list = window.currentVendorProducts || window.originalVendorProducts || [];
     const idx = list.findIndex(p => (p.handle||"") === handle);
     if (idx >= 0) list[idx].quantity = q;
   } catch {}
    const digits=Math.min(String(Math.abs(q)).length,4);
    badge.setAttribute("data-digits", String(digits));
    if (q<=0) badge.classList.add("qty-zero");
    else if (q<5) badge.classList.add("qty-low");
    else badge.classList.add("qty-ok");
    badge.classList.add("updated");
    badge.__loaded = true;
  }
}

/* ===== Modal grid building ===== */
async function resolveMissingVariantIds(list){
  await Promise.allSettled((list||[]).map(async p=>{
    if (p.variantId) return;
    if (!p.handle) return;
    p.variantId = await resolveVariantIdFromHandle(p.handle, { preferSku:p.sku });
  }));
}

function computeSlotArrays(items, gridSize, isMobile, pageIdx) {
  const capacity = gridSize * gridSize;
  const leftPage = isMobile ? (pageIdx + 1) : (pageIdx * 2 + 1);
  const rightPage = isMobile ? null : (pageIdx * 2 + 2);
  
  const leftSlots = new Array(capacity).fill(null);
  const rightSlots = rightPage ? new Array(capacity).fill(null) : null;
  
  // If no items, return empty arrays
  if (!items || items.length === 0) {
    return { leftSlots, rightSlots, leftPage, rightPage, capacity };
  }
  
  // CRITICAL FIX: Place products sequentially in the grid slots
  // This works whether they have binderPage/binderSlot or not
  for (let i = 0; i < items.length; i++) {
    if (i < capacity) {
      // Place in left grid
      leftSlots[i] = items[i];
    } else if (rightSlots && (i - capacity) < capacity) {
      // Place in right grid (if it exists)
      rightSlots[i - capacity] = items[i];
    }
    // Note: Products beyond both grids won't be shown on this page
    // (they'll appear when you paginate)
  }
  
  // Optional: Log for debugging
  console.log(`📊 Page ${pageIdx}: Left grid has ${leftSlots.filter(Boolean).length}/${capacity} items, Right grid has ${rightSlots?.filter(Boolean).length || 0}/${capacity || 0} items`);
  
  return { leftSlots, rightSlots, leftPage, rightPage, capacity };
}

function buildGridSkeleton(gridEl, capacity, gridSize, pageNumber, cardWidth=null, cardHeight=null){
  const frag = document.createDocumentFragment();
  for (let i=0;i<capacity;i++){
    const cell=document.createElement("div");
    if (cardWidth!=null && cardHeight!=null){
      cell.style.width=`${cardWidth}px`; cell.style.height=`${cardHeight}px`;
    }
    cell.style.display="flex";
    cell.style.justifyContent="center";
    cell.style.alignItems="center";
    cell.style.padding=(gridSize===5)?"0.12rem":"0.25rem";
    cell.style.boxSizing="border-box";
    cell.classList.add("empty-cell");
    cell.dataset.page=String(pageNumber);
    cell.dataset.slot=String(i+1);
    frag.appendChild(cell);
  }
  gridEl.replaceChildren(frag);
}

function hydrateGridCells(gridEl, slots, gridSize, vendorForModal){
  const cells = gridEl.children;
  const total = Math.min(cells.length, slots.length);
  const CHUNK = 16;
  let i = 0;

  (function pump(){
    const end = Math.min(total, i + CHUNK);
    for (; i < end; i++){
      const cell = cells[i];
      const item = slots[i];
      if (!item){ cell.classList.add('empty-cell'); continue; }

      cell.classList.remove('empty-cell');
      const px = Math.round(Math.min(cell.clientWidth || 300, cell.clientHeight || 300));
      const card = createProductCard(item, px, "auto", false, false, vendorForModal);
      card.classList.add("grid-mode");
      card.setAttribute("data-gridsize", gridSize);
      card.style.width="100%";
      card.style.height="100%";
      const frame=card.querySelector('.product-image-wrapper');
      if (frame) frame.setAttribute('data-gridsize', String(gridSize));
      cell.replaceChildren(card);
    }
    if (i < total){ Sched.micro(pump); }
    else {
      const root = document.getElementById('binder-content');
      ensureCartButtons(root);
      mountSlabs(root);
      Sched.idle(()=> refreshInventoryForFrames(root), 80);
    }
  })();
}

function ensureBinderChrome(binderContent){
  let layoutSelector = binderContent.querySelector('.layout-selector');
  let binder = binderContent.querySelector('.binder-layout');
  let grid1 = binder?.querySelector('.grid-section:nth-child(1)') || null;
  let grid2 = binder?.querySelector('.grid-section:nth-child(2)') || null;

  if (!layoutSelector){
    layoutSelector = document.createElement('div');
    layoutSelector.className = 'layout-selector';
    layoutSelector.innerHTML = `
      <button id="prev">⟨</button>
      <input type="text" id="binder-search" placeholder="Buscar...">
      <button id="binder-search-btn" class="clickable-btn">🔍</button>
      <button id="binder-reset-btn" class="clickable-btn" title="Restablecer búsqueda">⟳</button>

      <span class="sort-anchor" id="binder-sort-anchor">
        <button id="binder-sort-btn" class="clickable-btn" type="button" aria-haspopup="menu" aria-expanded="false" aria-controls="binder-sort-menu">⇅ Ordenar</button>
        <div id="binder-sort-menu" class="sort-menu" role="menu" hidden>
          <button role="menuitemradio" aria-checked="false" data-sort="binder">Binder (P→S)</button>
          <button role="menuitemradio" aria-checked="false" data-sort="title-asc">Nombre A–Z</button>
          <button role="menuitemradio" aria-checked="false" data-sort="price-asc">Precio ↑</button>
          <button role="menuitemradio" aria-checked="false" data-sort="price-desc">Precio ↓</button>
          <button role="menuitemradio" aria-checked="false" data-sort="qty-desc">Stock ↓</button>
        </div>
      </span>

      <span id="search-status" class="search-pill" style="display:none">
        <span class="icon">🔎</span><span class="q"></span><span class="count"></span>
        <button class="clear" title="Quitar">✕</button>
      </span>

      <label>Grid size:
        <select id="binder-grid-size"></select>
      </label>
      <button id="next">⟩</button>
    `;
    binderContent.appendChild(layoutSelector);

    initSortDropdownLocal(binderContent);
    hookToolbarResizeOnce();

    const select = layoutSelector.querySelector('#binder-grid-size');
    const isMob = isMobileViewport();
    select.replaceChildren(...(isMob ? [1,2,3] : [1,2,3,4,5]).map(n=>{
      const o=document.createElement('option');
      o.value=String(n); o.textContent=`${n}x${n}`;
      if (n===3) o.selected=true;
      return o;
    }));

    const searchInput=layoutSelector.querySelector("#binder-search");
    const searchBtn=layoutSelector.querySelector("#binder-search-btn");
    const resetBtn=layoutSelector.querySelector("#binder-reset-btn");
    const prevTopBtn=layoutSelector.querySelector("#prev");
    const nextTopBtn=layoutSelector.querySelector("#next");

    const handleModalSearchSubmit = ()=>{
      window.currentGlobalSearchRaw = searchInput.value||"";
      window.currentGlobalSearch = window.currentGlobalSearchRaw.trim().toLowerCase();
      window.currentPage=0;
      renderGridBinderInModal(window.currentVendorProducts);
    };
    searchBtn.addEventListener("click", ()=>{ handleModalSearchSubmit(); updateMobileToolbarInset(); });
    searchInput.addEventListener("keydown", (e)=>{ if (e.key==="Enter"){ handleModalSearchSubmit(); updateMobileToolbarInset(); } });

    resetBtn.addEventListener("click", ()=>{
      window.currentGlobalSearch=""; window.currentGlobalSearchRaw="";
      searchInput.value="";
      const g=document.getElementById("global-search-input"); if (g) g.value="";
      window.currentPage=0; binderContent.classList.remove("binder-search-active");
      renderGridBinderInModal(window.originalVendorProducts, true);
      updateMobileToolbarInset();
    });

    select.addEventListener("change",(e)=>{
      window.currentGridSize=parseInt(e.target.value,10);
      window.currentPage=0;
      renderGridBinderInModal(window.currentVendorProducts);
      updateMobileToolbarInset();
    });

    prevTopBtn.onclick = ()=>{ if ((window.currentPage||0)>0){ window.currentPage--; renderGridBinderInModal(window.currentVendorProducts); } };
    nextTopBtn.onclick = ()=>{ const mp = window.__maxPage||0; if ((window.currentPage||0)<mp){ window.currentPage++; renderGridBinderInModal(window.currentVendorProducts); } };
  }

  if (!binder){
    binder = document.createElement('div');
    binder.className = 'binder-layout';
    grid1 = document.createElement('div'); grid1.className = 'grid-section';
    grid2 = document.createElement('div'); grid2.className = 'grid-section';
    binder.appendChild(grid1); binder.appendChild(grid2);
    binderContent.appendChild(binder);
  }

  const isMobile = isMobileViewport();
  grid1 = binder.querySelector('.grid-section:nth-child(1)');
  grid2 = binder.querySelector('.grid-section:nth-child(2)');

  if (isMobile && grid2){ binder.removeChild(grid2); grid2 = null; }
  if (!isMobile && !grid2){ grid2 = document.createElement('div'); grid2.className='grid-section'; binder.appendChild(grid2); }

  return { layoutSelector, binder, grid1, grid2 };
}

function updateControlsUI(binderContent, filteredCanonical){
  const statusEl = binderContent.querySelector('#search-status');
  const hasQuery = !!(window.currentGlobalSearch||"");
  binderContent.classList.toggle('binder-search-active', hasQuery);
  
  if (hasQuery && statusEl){  // ✅ Check if statusEl exists
    statusEl.style.display = 'inline-flex';
    const qEl = statusEl.querySelector('.q');
    const countEl = statusEl.querySelector('.count');
    if (qEl) qEl.textContent = `“${(window.currentGlobalSearchRaw||"").trim()}”`;
    if (countEl) countEl.textContent = `• ${filteredCanonical.length} resultados`;
  } else if (statusEl) {
    statusEl.style.display = 'none';
  }
}

// ========== FUNCIONES PARA CONTROLAR EL LOADER AMBIENTAL ==========

function showAmbientLoader() {
  const loader = document.getElementById('ambient-loader');
  if (!loader) {
    console.warn('⚠️ Ambient loader not found');
    return;
  }
  
  // Forzar reset completo
  loader.style.display = 'flex';
  loader.classList.remove('fade-out');
  
  // Resetear animación del círculo de progreso
  const progressFill = loader.querySelector('.progress-fill');
  const progressPercent = loader.querySelector('.progress-percent');
  
  if (progressFill) {
    // Clonar y reemplazar para resetear la animación completamente
    const newFill = progressFill.cloneNode(true);
    progressFill.parentNode.replaceChild(newFill, progressFill);
    newFill.style.animation = 'none';
    newFill.offsetHeight;
    newFill.style.animation = 'progressFill 3s ease-in-out forwards';
  }
  
  if (progressPercent) {
    progressPercent.textContent = '0%';
    
    let startTime = null;
    const duration = 3000;
    
    function animateProgress(timestamp) {
      if (!startTime) startTime = timestamp;
      const elapsed = timestamp - startTime;
      const newProgress = Math.min(100, Math.floor((elapsed / duration) * 100));
      if (progressPercent) progressPercent.textContent = `${newProgress}%`;
      
      if (newProgress < 100) {
        requestAnimationFrame(animateProgress);
      }
    }
    
    // Cancelar animación anterior si existe
    if (window._progressAnimationFrame) {
      cancelAnimationFrame(window._progressAnimationFrame);
    }
    window._progressAnimationFrame = requestAnimationFrame(animateProgress);
  }
  
  console.log('✨ Ambient loader shown');
}

function hideAmbientLoader() {
  const loader = document.getElementById('ambient-loader');
  if (!loader) return;
  
  loader.classList.add('fade-out');
  setTimeout(() => {
    if (loader && loader.parentNode) {
      loader.style.display = 'none';
      loader.classList.remove('fade-out');
    }
  }, 800);
}

function renderGridBinderInModal(productSet, fromUser=false){
  const modal=document.getElementById("binder-modal");
  const binderContent=document.getElementById("binder-content");
  
  // CRITICAL FIX: Asegurar que productSet se guarda correctamente
  if (fromUser){
    window.originalVendorProducts = productSet;
    window.currentVendorProducts = productSet ? [...productSet] : [];
  }
  
  // Si no hay productos, mostrar mensaje y ocultar loader
  if (!window.currentVendorProducts || window.currentVendorProducts.length === 0) {
    console.log('⚠️ No products to display');
    if (binderContent) {
      const existingLayout = binderContent.querySelector('.binder-layout');
      if (existingLayout) existingLayout.innerHTML = '<div style="text-align:center;padding:2rem;color:#fff;">No hay productos para mostrar</div>';
    }
    hideAmbientLoader();
    return;
  }
  window.renderGridBinderInModal = renderGridBinderInModal;

  const doClose = () => window.__binderClose();
  modal.onclick = (e) => {
    const bc = document.getElementById('binder-content');
    if (bc && !bc.contains(e.target)) doClose();
  };
  const closeBtn = document.getElementById('close-modal');
  if (closeBtn && !closeBtn.__binderBound) {
    closeBtn.addEventListener('click', doClose);
    closeBtn.__binderBound = true;
  }

  if (fromUser){
    const title = (window.activeVendor?.vendorName ? `${window.activeVendor.vendorName} Binder` : 'NENSONS BINDERS');
    window.__binderOpen(title);
    Sched.raf(updateMobileToolbarInset);
  }

  Sched.raf(()=>{
    const isMobile=isMobileViewport();
    const localSearch=(window.currentGlobalSearch||"").trim().toLowerCase();
    const baseVendorProducts = window.originalVendorProducts || [];

    const filtered = localSearch
      ? baseVendorProducts.filter(p =>
          p.title.toLowerCase().includes(localSearch) ||
          (p.tags||[]).some(tag => (tag||"").toLowerCase().includes(localSearch))
        )
      : baseVendorProducts;

    const filteredCanonical = filtered.slice().sort(byBinderThenTitle);
    window.currentVendorProducts = filteredCanonical;

    Sched.idle(()=> resolveMissingVariantIds(filteredCanonical), 60);

    const currentGridSize = window.currentGridSize || getResponsiveGridSize();
    const itemsPerPage = currentGridSize * currentGridSize * (isMobile ? 1 : 2);

    const maxBinderPage = Math.max(0, ...filteredCanonical.map(p => Number(p?.binderPage || 0)));
    const maxPage = maxBinderPage > 0
      ? (isMobile ? Math.max(0, maxBinderPage - 1) : Math.max(0, Math.ceil(maxBinderPage / 2) - 1))
      : Math.max(0, Math.ceil(filteredCanonical.length / itemsPerPage) - 1);

    if ((window.currentPage || 0) > maxPage) window.currentPage = maxPage;
    window.__maxPage = maxPage;

    const { layoutSelector, binder, grid1, grid2 } = ensureBinderChrome(binderContent);

    const select = layoutSelector.querySelector('#binder-grid-size');
    if (select && select.value !== String(currentGridSize)) select.value = String(currentGridSize);

    const searchInput=layoutSelector.querySelector('#binder-search');
    if (searchInput) searchInput.value = window.currentGlobalSearchRaw || "";

    const prevTopBtn=layoutSelector.querySelector("#prev");
    const nextTopBtn=layoutSelector.querySelector("#next");

    if (prevTopBtn) prevTopBtn.style.opacity = (window.currentPage||0)>0?"0.9":"0.5";
    if (nextTopBtn) nextTopBtn.style.opacity = (window.currentPage||0)<maxPage?"0.9":"0.5";

    binder.style.setProperty('--grid-size', currentGridSize);
    binder.classList.remove('grid-1','grid-2','grid-3','grid-4','grid-5');
    binder.classList.add(`grid-${currentGridSize}`, 'grid-3');
    [grid1, grid2].filter(Boolean).forEach(g=>{
      g.classList.remove('grid-1','grid-2','grid-3','grid-4','grid-5');
      g.classList.add(`grid-${currentGridSize}`, 'grid-3');
    });

    let cardWidth=null, cardHeight=null;
    if (!isMobile){
      const px=(v)=>Number.parseFloat(v)||0;
      const bcs=getComputedStyle(binder);
      const innerW=binder.clientWidth - px(bcs.paddingLeft)-px(bcs.paddingRight);
      const innerH=binder.clientHeight- px(bcs.paddingTop) -px(bcs.paddingBottom);
      const layoutGap=px(bcs.columnGap||bcs.gap);
      const gcs=getComputedStyle(grid1);
      const colGap=px(gcs.columnGap||gcs.gap), rowGap=px(gcs.rowGap||gcs.gap);
      const gPadX=px(gcs.paddingLeft)+px(gcs.paddingRight), gPadY=px(gcs.paddingTop)+px(gcs.paddingBottom);
      const perGridW=(innerW - (grid2?layoutGap:0)) / (grid2?2:1);
      const rem=Number.parseFloat(getComputedStyle(binder).fontSize)||16;
      const cellPad=currentGridSize===5?0.12:0.25;

      const columnWidth=(perGridW - gPadX - ((currentGridSize)-1)*colGap) / currentGridSize;
      const rowHeight =(innerH  - gPadY - ((currentGridSize)-1)*rowGap) / currentGridSize;
      cardWidth = Math.floor(columnWidth - 2*cellPad*rem);
      cardHeight = Math.floor(rowHeight - 2*cellPad*rem);
    }

    const pageIdx = window.currentPage || 0;
    const { leftSlots, rightSlots, leftPage, rightPage, capacity } =
      computeSlotArrays(filteredCanonical, currentGridSize, isMobile, pageIdx);

    buildGridSkeleton(grid1, capacity, currentGridSize, leftPage, cardWidth, cardHeight);
    if (grid2 && rightSlots) buildGridSkeleton(grid2, capacity, currentGridSize, rightPage, cardWidth, cardHeight);

    const vendorForModal = window.activeVendor?.vendorName || "";
    hydrateGridCells(grid1, leftSlots, currentGridSize, vendorForModal);
    if (grid2 && rightSlots) hydrateGridCells(grid2, rightSlots, currentGridSize, vendorForModal);

    updateControlsUI(binderContent, filteredCanonical);

    enableSwipePaging(
      binderContent,
      ()=>{ if ((window.currentPage||0)>0){ window.currentPage--; renderGridBinderInModal(window.currentVendorProducts); } },
      ()=>{ if ((window.currentPage||0)<maxPage){ window.currentPage++; renderGridBinderInModal(window.currentVendorProducts); } }
    );

    const prevBtn=binderContent.querySelector(".modal-prev");
    const nextBtn=binderContent.querySelector(".modal-next");
    if (prevBtn) prevBtn.onclick=(e)=>{ e.stopPropagation(); if ((window.currentPage||0)>0){ window.currentPage--; renderGridBinderInModal(window.currentVendorProducts); } };
    if (nextBtn) nextBtn.onclick=(e)=>{ e.stopPropagation(); if ((window.currentPage||0)<maxPage){ window.currentPage++; renderGridBinderInModal(window.currentVendorProducts); } };

    updateMobileToolbarInset(); hookToolbarResizeOnce();
    try { document.dispatchEvent(new CustomEvent('binder:data-ready', { detail: { root: binderContent, gridSize: currentGridSize, page: window.currentPage } })); } catch {}
    
    // ✅ ESPERAR a que el modal esté completamente visible y renderizado
    // Usamos requestAnimationFrame para asegurar que el DOM se haya pintado
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        // Verificar que el modal está abierto y visible
        const modalIsOpen = modal.classList.contains('is-open') || 
                           document.documentElement.classList.contains('binder-aio-active');
        
        if (modalIsOpen) {
          // Pequeño retraso adicional para que las imágenes comiencen a cargar
          setTimeout(() => {
            hideAmbientLoader();
          }, 500);
        } else {
          // Si el modal no está abierto, esperar un poco más
          setTimeout(() => {
            if (modal.classList.contains('is-open') || 
                document.documentElement.classList.contains('binder-aio-active')) {
              hideAmbientLoader();
            } else {
              // Fallback: ocultar después de 2 segundos máximo
              setTimeout(() => hideAmbientLoader(), 2000);
            }
          }, 500);
        }
      });
    });
  });
}

/* ===== Sort dropdown (UI-only, canonical order preserved unless applied) ===== */
function initSortDropdownLocal(root = document.getElementById('binder-content')) {
  const wrap = root?.querySelector('.layout-selector');
  const btn  = wrap?.querySelector('#binder-sort-btn');
  const menu = wrap?.querySelector('#binder-sort-menu');
  if (!wrap || !btn || !menu) return;

  const anchor = wrap.querySelector('#binder-sort-anchor') || btn.parentElement;
  if (menu.parentElement !== anchor) anchor.appendChild(menu);

  const items = Array.from(menu.querySelectorAll('[role="menuitemradio"][data-sort]'));
  const open = ()=>{ if (!menu.hidden){return} menu.hidden=false; btn.setAttribute('aria-expanded','true'); };
  const close=()=>{ if (menu.hidden){return} menu.hidden=true; btn.setAttribute('aria-expanded','false'); };

  btn.addEventListener('click', (e)=>{ e.stopPropagation(); menu.hidden ? open() : close(); });
  document.addEventListener('click', (e)=>{ if (!menu.hidden && !menu.contains(e.target) && e.target !== btn) close(); });
  document.addEventListener('keydown', (e)=>{ if (e.key==='Escape' && !menu.hidden){ e.preventDefault(); close(); } });

  const setChecked = (mode)=> items.forEach(i => i.setAttribute('aria-checked', i.dataset.sort===mode ? 'true' : 'false'));

  const applySort = (list, mode) => {
    const arr = (list||[]).slice();
    if (mode === 'title-asc') return arr.sort((a,b)=> (a.title||'').localeCompare(b.title||''));
    if (mode === 'price-asc') return arr.sort((a,b)=> (Number(a.price)||0)-(Number(b.price)||0));
    if (mode === 'price-desc') return arr.sort((a,b)=> (Number(b.price)||0)-(Number(a.price)||0));
    if (mode === 'qty-desc') return arr.sort((a,b)=> {
    const aq = Number.isFinite(Number(a.quantity)) ? Number(a.quantity) : -1;
    const bq = Number.isFinite(Number(b.quantity)) ? Number(b.quantity) : -1;
    return bq - aq;
  });
    return arr.sort(byBinderThenTitle); // binder canonical
  };

  items.forEach(i => {
    i.addEventListener('click', () => {
      setChecked(i.dataset.sort);
      btn.textContent = `⇅ ${i.textContent}`;
      window.currentSort = i.dataset.sort;

      const isOpen =
        document.documentElement.classList.contains('binder-aio-active') ||
        document.getElementById('binder-modal')?.classList.contains('is-open');

      if (isOpen && Array.isArray(window.currentVendorProducts)){
        window.currentVendorProducts = applySort(window.currentVendorProducts, window.currentSort);
        renderGridBinderInModal(window.currentVendorProducts);
      } else if (typeof window.renderAllVendors === 'function') {
        window.renderAllVendors();
      }
      close();
    });
  });
}

/* Overlay ONLY binder positions from backend for a single vendor */
async function overlayPositionsForVendor(masterList = [], email = "") {
  const safe = Array.isArray(masterList) ? masterList.slice() : [];
  let backend = [];
  try { backend = await fetchBinderProductsForEmail(email); }
  catch (e) { console.warn("overlayPositions: backend fetch failed", e); }

  const posByHandle = new Map();
  const toHandle = (p) => p?.handle || handleFromUrl(p?.url || "");

  backend.forEach(p => {
    const h = toHandle(p);
    const pg = Number(p?.binderPage || 0);
    const sl = Number(p?.binderSlot || 0);
    if (h && pg > 0 && sl > 0) posByHandle.set(h, { binderPage: pg, binderSlot: sl });
  });

  const merged = safe.map(p => {
    const h = toHandle(p);
    if (h && posByHandle.has(h)) {
      const { binderPage, binderSlot } = posByHandle.get(h);
      return { ...p, binderPage, binderSlot };
    }
    return { ...p, binderPage: p?.binderPage ?? null, binderSlot: p?.binderSlot ?? null };
  });

  return merged.sort(byBinderThenTitle);
}

/* ===== Page renderer (vendors) ===== */
function createProductCardPreview(p, i, vendorName){
  const isTopThumb = i < 4;
  return createProductCard(p, 300, isTopThumb ? "high" : "low", isTopThumb, true, vendorName);
}


/* =========================================================
   VENDOR ACTION ROW — Rating · Reviews · Contact · Share
   Reuses the old reviews-row footprint, so vendor card height
   does not grow. Share is moved here when vendor-og-tags.js
   injects it.
========================================================= */
function nbCanonicalEmail(value){
  return String(value || '').trim().toLowerCase();
}

async function nbResolveContactProductId(product){
  if (!product) return null;

  // Prefer an existing Product GID if the backend payload retained it.
  const gid = String(product.gid || '');
  if (/^gid:\/\/shopify\/Product\//i.test(gid)) {
    const m = gid.match(/(\d+)$/);
    if (m) return m[1];
  }

  // Otherwise resolve the Shopify product ID from the product JSON endpoint.
  let handle = String(product.handle || '').trim();
  if (!handle && product.url) {
    const m = String(product.url).match(/\/products\/([^/?#]+)/i);
    if (m) handle = m[1];
  }
  if (!handle) return null;

  try {
    const res = await fetch('/products/' + encodeURIComponent(handle) + '.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    });
    if (!res.ok) return null;
    const data = await res.json();
    return data && data.id ? String(data.id) : null;
  } catch (_) {
    return null;
  }
}

function nbCreateVendorContactButton({ vendorEmail, product, vendorName }){
  const currentEmail = nbCanonicalEmail(window.CURRENT_CUSTOMER_EMAIL || '');
  const sellerEmail  = nbCanonicalEmail(vendorEmail || '');

  // Match the original contact snippet: seller never contacts themselves.
  if (currentEmail && sellerEmail && currentEmail === sellerEmail) return null;

  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'vendor-contact-action';
  btn.setAttribute('aria-label', 'Contactar a ' + String(vendorName || 'vendedor'));
  btn.innerHTML = '<span class="vendor-contact-action__icon" aria-hidden="true">✉</span><span class="vendor-contact-action__label">Contactar</span>';

  btn.addEventListener('click', async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (btn.disabled) return;

    // Preserve original login behavior.
    if (!nbCanonicalEmail(window.CURRENT_CUSTOMER_EMAIL || '')) {
      const returnUrl = location.pathname + location.search + location.hash;
      location.href = '/account/login?return_url=' + encodeURIComponent(returnUrl);
      return;
    }

    const label = btn.querySelector('.vendor-contact-action__label');
    const original = label ? label.textContent : 'Contactar';
    btn.disabled = true;
    btn.classList.add('is-loading');
    if (label) label.textContent = 'Abriendo';

    try {
      const productId = await nbResolveContactProductId(product);
      if (!productId) throw new Error('No product id');

      const res = await fetch('/apps/nb/chat/start', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ productId: String(productId) })
      });

      const raw = await res.text();
      let data = {};
      try { data = JSON.parse(raw); } catch (_) {}

      if (!res.ok || data.success === false || !data.conversationId) {
        throw new Error(data.error || ('HTTP ' + res.status));
      }

      if (label) label.textContent = 'Listo';
      location.href = '/pages/mensajes?c=' + encodeURIComponent(data.conversationId);
    } catch (err) {
      console.warn('Could not start vendor conversation:', err);
      btn.disabled = false;
      btn.classList.remove('is-loading');
      btn.classList.add('is-error');
      if (label) label.textContent = 'Reintentar';
      setTimeout(() => {
        btn.classList.remove('is-error');
        if (label && !btn.disabled) label.textContent = original;
      }, 1800);
    }
  });

  return btn;
}

function nbFindVendorShareControl(section, actionsRow){
  if (!section) return null;
  const nodes = section.querySelectorAll('button, a, [role="button"]');
  for (const el of nodes) {
    if (actionsRow && actionsRow.contains(el)) continue;
    if (el.classList && (el.classList.contains('vendor-button') || el.classList.contains('banner-edit'))) continue;
    const hay = [
      el.textContent,
      el.getAttribute('aria-label'),
      el.getAttribute('title'),
      el.className
    ].filter(Boolean).join(' ').toLowerCase();
    if (/\bshare\b|compartir/.test(hay)) return el;
  }
  return null;
}

function nbRemoveExtraVendorShareControls(section, actionsRow){
  if (!section) return;
  const nodes = Array.from(section.querySelectorAll('button, a, [role="button"]'));
  nodes.forEach((el) => {
    if (actionsRow && actionsRow.contains(el)) return;
    if (el.classList && (el.classList.contains('vendor-button') || el.classList.contains('banner-edit'))) return;
    const hay = [
      el.textContent,
      el.getAttribute('aria-label'),
      el.getAttribute('title'),
      el.className
    ].filter(Boolean).join(' ').toLowerCase();
    if (/\bshare\b|compartir/.test(hay)) el.remove();
  });
}

function nbMountVendorShareIntoActions(section, actionsRow){
  if (!section || !actionsRow) return;

  const syncShare = () => {
    let rowShare = actionsRow.querySelector('.vendor-share-action');

    if (!rowShare) {
      const share = nbFindVendorShareControl(section, actionsRow);
      if (share) {
        share.classList.add('vendor-share-action');
        actionsRow.appendChild(share);
        rowShare = share;
      }
    }

    // vendor-og-tags.js may also inject a second SHARE control in the banner.
    // Keep the action-row SHARE and remove only duplicate banner/header copies.
    nbRemoveExtraVendorShareControls(section, actionsRow);
    return Boolean(rowShare);
  };

  syncShare();

  // Keep watching briefly because vendor-og-tags.js can inject controls later.
  const observer = new MutationObserver(() => syncShare());
  observer.observe(section, { childList:true, subtree:true });
  setTimeout(() => observer.disconnect(), 10000);
}

function renderAllVendors(){
  const container=document.getElementById("vendor-section");
  const fullVendorData = window.__fullVendorData || {};
  container.innerHTML="";

  const entries = Object.entries(fullVendorData)
    .sort((a, b) => {
      const ratingA = Number(a[1]?.vendorRatingAvg ?? a[1]?.vendorRating ?? 0) || 0;
      const ratingB = Number(b[1]?.vendorRatingAvg ?? b[1]?.vendorRating ?? 0) || 0;
      if (ratingB !== ratingA) return ratingB - ratingA; // highest rating first
      return (a[1]?.vendorName || a[0]).localeCompare(b[1]?.vendorName || b[0]); // alphabetical tiebreaker
    });

  const frag = document.createDocumentFragment();

  for (const [key, bucket] of entries){
    // ===== UPDATED WHOLE BLOCK (grouped-safe banner key + canonical email) =====

const vendorName = bucket.vendorName || key;

// ✅ IMPORTANT: grouped buckets often have bucket.email === "grouped" / junk.
// Pick a real email from bucket/email/products, else fallback to key.
const email = pickPrimaryVendorEmail(bucket, key) || (bucket.email || key);

const products = Array.isArray(bucket.products) ? bucket.products.slice() : [];

const search = (window.currentGlobalSearch || "");
const matchesVendor = vendorSearchHaystack(bucket, key).includes(search);

const matchingProducts = !search ? products : products.filter(p =>
  p.title.toLowerCase().includes(search) ||
  (p.tags || []).some(tag => (tag || "").toLowerCase().includes(search))
);

if (search && !matchesVendor && matchingProducts.length === 0) continue;

const visibleProducts = search
  ? (matchesVendor ? products : matchingProducts)
  : products;

const section = document.createElement("section");
section.className = "vendor-group slab-scope";

// ✅ ONE canonical identity for EVERYTHING (ratings + profile + logo)
const vendorIdentityKey = getVendorIdentityKey(bucket, key, vendorName);

// email used for overlayPositions + display only (may be empty if unknown)
const identityEmail = canonicalizeEmail(vendorIdentityKey) || ""; // will be "" if key isn’t an email

// Vendor profile (metaobject) lookup MUST use the same identity key the backend uses for vendor_key
 const profile = (window.VENDOR_PROFILES && window.VENDOR_PROFILES[vendorIdentityKey]) || null;
// Prefer profile values, fallback to bucket values
const mergedVendorName = (vendorName || profile?.vendor_name || key).trim();

// ✅ Store name for THIS vendor group (custom.user_store).
// Never falls back to CURRENT_CUSTOMER_USER_STORE — that's the logged-in user, not the vendor.
const vendorStoreName = String(
  bucket.userStore ||
  bucket.user_store ||
  profile?.user_store ||
  bucket.vendorLastName ||
  mergedVendorName || ""
).trim();

// ✅ vendor email is contact/display; keep it canonical if present
 const mergedVendorEmail = (
   canonicalizeEmail(profile?.vendor_email || "") ||
   canonicalizeEmail(email || "") ||
   canonicalizeEmail(bucket?.email || "") ||
   ""
 ).trim();
// ✅ Rating key MUST be the SAME identity key we use everywhere.
 const vendorRatingKey = vendorIdentityKey;

// initial fallback value only (real avg will come from refreshVendorAverageIntoBanner)
const mergedCount  = Number(bucket?.vendorRatingCount ?? 0);
const mergedRating = Number(bucket?.vendorRatingAvg ?? bucket?.vendorRating ?? profile?.vendor_rating ?? 0) || 0;

// Derive score text + tier immediately from what we already have
const initialScore = (
  Number.isFinite(mergedCount) && mergedCount > 0 &&
  Number.isFinite(mergedRating) && mergedRating > 0
) ? mergedRating.toFixed(1) : "—";

const initialTier = ratingTierFromSummary(mergedRating, mergedCount);

section.dataset.vendorKey = vendorIdentityKey;
section.dataset.company   = mergedVendorName;
section.dataset.userStore = vendorStoreName;

["tl","tr","bl","br"].forEach(pos => {
  const c = document.createElement("span");
  c.className = `corner ${pos}`;
  section.appendChild(c);
});

const button = document.createElement("button");
button.className = "vendor-button";
button.dataset.vendorKey    = vendorRatingKey;      // ✅ canonical identity for selectors + rating paint
button.dataset.vendorKeyRaw = vendorIdentityKey;    // keep, but same value now (prevents drift)
button.dataset.vendorEmail  = mergedVendorEmail || "";
button.dataset.userStore    = vendorStoreName;
button.innerHTML = `
  <svg class="vendor-svg-title"
       viewBox="0 0 1200 160"
       preserveAspectRatio="xMidYMid meet"
       overflow="visible"
       aria-label="${escHtml(mergedVendorName)}"
       role="img">
    <g transform="translate(600 80) scale(2) translate(-600 -80)">
      <text x="50%"
            y="50%"
            dominant-baseline="middle"
            text-anchor="middle"
            font-size="96">
        ${escHtml(vendorStoreName)}
      </text>
      <line class="underline" x1="144" x2="1056" y1="126" y2="126" />
    </g>
    <line class="underline" x1="144" x2="1056" y1="126" y2="126" />
  </svg>
`;

// ✅ FIX 4: paint correct score + tier class on first render — no flash of "—"
const ratingUI = `
  <div
    class="vendor-rating-cta ${initialTier ? 'is-' + initialTier : 'is-unrated'}"
    data-tier="${initialTier || 'unrated'}"
    role="button"
    tabindex="0"
    aria-label="Calificar al vendedor ${escHtml(mergedVendorName)}"
    title="Califíca al Vendedor">
    <span class="star">★</span>
    <span class="score">${initialScore}</span>
  </div>
`;

button.insertAdjacentHTML("beforeend", ratingUI);

// ✅ FIX 4: background-only refresh — no blocking round-trip on render
// (keeps badge fresh if another user submits a rating in a different tab)
if (vendorRatingKey) {
  Sched.idle(() => refreshVendorAverageIntoBanner(vendorRatingKey, mergedVendorEmail || ""), 200);
}

// Click opens rating modal
const ratingBtn = button.querySelector(".vendor-rating-cta");
if (ratingBtn && !ratingBtn.__wired) {
  ratingBtn.__wired = true;

  const open = (e) => {
    e.preventDefault();
    e.stopPropagation();
    openVendorRatingModal({
  vendorKey: vendorRatingKey,
  vendorEmail: identityEmail || mergedVendorEmail || "",
  vendorName: mergedVendorName
});
  };

  ratingBtn.addEventListener("click", open);
  ratingBtn.addEventListener("keydown", (e) => {
    if (e.key === "Enter" || e.key === " ") open(e);
  });
}

button.addEventListener("click", async () => {
  // ✅ MOSTRAR LOADER INMEDIATAMENTE - PRIMERA LÍNEA
  showAmbientLoader();

  // Reflect the open binder in the URL (shareable + back button works)
  try {
    const slug = storeSlug(bucket.userStore || profile?.user_store || mergedVendorName);
    if (slug) {
      const want = location.pathname + '?store=' + encodeURIComponent(slug);
      if (location.pathname + location.search !== want) {
        history.pushState({ binderStore: slug }, '', want);
      }
    }
  } catch {}
  
window.activeVendor = {
    vendorKey: vendorIdentityKey,
    vendorName: mergedVendorName,
    email: mergedVendorEmail || email,
    rating: mergedRating,
    userStore: vendorStoreName          // ✅ store name for THIS vendor
  };

  window.currentGlobalSearch = "";
  window.currentGlobalSearchRaw = "";
  const g = document.getElementById("global-search-input");
  if (g) g.value = "";
  window.currentPage = 0;

  try {
    const withPositions = await overlayPositionsForVendor(products, (mergedVendorEmail || email));
    
    window.originalVendorProducts = withPositions;
    window.currentVendorProducts = withPositions;
    
    Sched.idle(() => resolveMissingVariantIds(withPositions), 60);
    renderGridBinderInModal(withPositions, true);
  } catch (err) {
    console.warn("Overlay positions failed, falling back:", err);
    
    window.originalVendorProducts = products;
    window.currentVendorProducts = products;
    
    renderGridBinderInModal(products, true);
  }
});

// ✅ banner edit gate should use canonical email too
if (canEditVendorBanner(mergedVendorEmail || email)) {
  const editBtn = document.createElement("button");
  editBtn.type = "button";
  editBtn.className = "banner-edit";
  editBtn.textContent = "Cambiar banner";
  editBtn.addEventListener("click", (e) => {
    e.stopPropagation();
    pickAndUploadBanner(vendorIdentityKey, button);
  });
  section.appendChild(editBtn);
}

// Paint cached vendor banner immediately (prevents blink on re-render)
const cachedBanner = VendorBannerCache.get(vendorIdentityKey);
if (cachedBanner?.ok && cachedBanner?.url) {
  applyVendorBanner(button, cachedBanner.url, { forceHasLogo:true });
} else {
  applyVendorBanner(button, "", { forceHasLogo:false });
}

// ✅ Prevent async banner fetch from overwriting a newly-uploaded banner
const bannerToken = `${vendorIdentityKey}:${Date.now()}:${Math.random().toString(16).slice(2)}`;
button.__bannerToken = bannerToken;

fetchVendorLogoURL(vendorIdentityKey)
  .then(async (url) => {
    const u = String(url || "").trim();
    if (!u) {
      VendorBannerCache.set(vendorIdentityKey, { url: "", ok: false });
      return applyVendorBannerSafely(button, "", bannerToken);
    }

    // If we already have this banner painted, skip repaint
    const prev = VendorBannerCache.get(vendorIdentityKey);
    if (prev?.ok && prev?.url === u) return;

    // Probe, then cache and apply
    const ok = await probeImageURL(u);
    VendorBannerCache.set(vendorIdentityKey, { url: u, ok: !!ok });
    return applyVendorBannerSafely(button, ok ? u : "", bannerToken);
  })
  .catch(() => {
    VendorBannerCache.set(vendorIdentityKey, { url: "", ok: false });
    applyVendorBannerSafely(button, "", bannerToken);
  });

    const preview=document.createElement("div");
    preview.className="carousel grid-3";

    const pfrag = document.createDocumentFragment();
    const previewProducts = visibleProducts.slice().sort(byBinderThenTitle).slice(0, 6);
previewProducts.forEach((p, i) => pfrag.appendChild(createProductCardPreview(p, i, vendorName)));
    preview.appendChild(pfrag);

    // ── Article link pill ─────────────────────────────────────────────────────
    const articleUrl = vendorArticleUrl(vendorIdentityKey, bucket.articleUrl, mergedVendorName);
    const articleLink = document.createElement("a");
    articleLink.href      = articleUrl;
    articleLink.className = "vendor-article-link";
    articleLink.setAttribute("aria-label", `Ver reseñas de ${mergedVendorName}`);
    articleLink.innerHTML = `
      <span class="vendor-article-link__icon">💬</span>
      <span class="vendor-article-link__text">Reseñas</span>
      <span class="vendor-article-link__arrow">→</span>
    `;

    // Compact action row: uses the same vertical footprint as the old Reviews strip.
    const actionsRow = document.createElement("div");
    actionsRow.className = "vendor-actions-row";
    actionsRow.setAttribute("role", "group");
    actionsRow.setAttribute("aria-label", `Acciones de ${mergedVendorName}`);

    // Move the already-wired rating control out of the banner and into the row.
    if (ratingBtn) actionsRow.appendChild(ratingBtn);
    actionsRow.appendChild(articleLink);

    const contactProduct = previewProducts.find(p => p && (p.handle || p.url || p.gid)) || products[0] || null;
    const contactBtn = nbCreateVendorContactButton({
      vendorEmail: mergedVendorEmail || email || "",
      product: contactProduct,
      vendorName: mergedVendorName
    });
    if (contactBtn) actionsRow.appendChild(contactBtn);
    else actionsRow.classList.add("without-contact");

    section.appendChild(button);
    section.appendChild(actionsRow);
    section.appendChild(preview);

    // SHARE is injected by another asset; move it into the fourth slot when available.
    nbMountVendorShareIntoActions(section, actionsRow);
    frag.appendChild(section);
  }

  container.appendChild(frag);

  mountSlabs(container);
  Sched.idle(()=> refreshInventoryForFrames(container), 100);

  try { document.dispatchEvent(new CustomEvent('binder:data-ready', { detail: { root: container } })); } catch {}
}
window.renderAllVendors = renderAllVendors;
function autoOpenBinderFromContext(){
  const full = window.__fullVendorData || {};
  const entries = Object.entries(full);

  const { slug: hintSlug, legacy: hint } = getInitialVendorHint();
  const hasHint = !!(hintSlug || hint);

  const hLower = hint.toLowerCase();
  const hCanon = canonicalizeEmail(hint);

  let selectedBucket = null;
  let selectedEmail  = null;
  let selectedName   = null;
  let selectedStore  = null;

  if (hasHint && entries.length){
    for (const [key, bucket] of entries){
      const name = bucket.vendorName || key;

      const vendorIdentityKey = getVendorIdentityKey(bucket, key, name);
      const canonEmail = canonicalizeEmail(vendorIdentityKey); // works if identityKey is an email

      // for opening/overlay, we still want the best contact email we can find
      const email = pickPrimaryVendorEmail(bucket, key) || canonicalizeEmail(bucket?.email || "") || "";

      const profile = (window.VENDOR_PROFILES && window.VENDOR_PROFILES[vendorIdentityKey]) || null;

      let match = false;

      // 1) NEW: public slug match (?store=neo-tcg)
      if (hintSlug) match = bucketSlugs(bucket, key, profile).has(hintSlug);

      // 2) LEGACY: email / key / name match — keeps old links alive
      if (!match && hint){
        match = (
          String(vendorIdentityKey).toLowerCase() === hLower ||
          String(key).toLowerCase()               === hLower ||
          String(name).toLowerCase()              === hLower ||
          (hCanon && canonEmail && hCanon === canonEmail)
        );
      }

      if (match){
        selectedBucket = bucket;
        selectedEmail  = email;
        selectedName   = name;
        selectedStore  = String(
          bucket.userStore ||
          bucket.user_store ||
          profile?.user_store ||
          bucket.vendorLastName ||
          name || ""
        ).trim();
        break;
      }
    }
  }

  const modal = document.getElementById('binder-modal');
  const alreadyOpen =
    document.documentElement.classList.contains('binder-aio-active') ||
    (modal && modal.classList.contains('is-open'));

    // 1) If we have a specific vendor from previous page → open that binder
  if (selectedBucket){
    if (window.__binderVendorAutoOpened) return;
    window.__binderVendorAutoOpened = true;

    const selectedCanonEmail = canonicalizeEmail(selectedEmail) || "";

const vendorKey = getVendorIdentityKey(selectedBucket, selectedEmail || "", selectedName || "");

const products = Array.isArray(selectedBucket.products)
  ? selectedBucket.products.slice()
  : [];

window.activeVendor = {
  vendorKey,
  vendorName: selectedName,
  email: selectedCanonEmail || selectedEmail,
  userStore: selectedStore || ""
};


    overlayPositionsForVendor(products, canonicalizeEmail(selectedEmail) || selectedEmail)
      .then(withPositions => {
        resolveMissingVariantIds(withPositions);
        renderGridBinderInModal(withPositions, true);
      })
      .catch(() => {
        renderGridBinderInModal(products, true);
      });

    return;
  }

  // 2) No specific vendor hint: do NOT auto-open the binder.
  //    Just leave the page in normal vendor-list mode.
}

// Empty state styles injected above
const emptyStateStyles = `
  .empty-binders-state {
    grid-column: 1 / -1;
    text-align: center;
    padding: 4rem 2rem;
    background: linear-gradient(145deg, #0a0a0a, #1a1a1a);
    border-radius: 32px;
    border: 1px solid rgba(209, 0, 0, 0.2);
    box-shadow: 0 20px 40px rgba(0,0,0,0.5), 0 0 0 1px rgba(209,0,0,0.1) inset;
    margin: 2rem auto;
    max-width: 800px;
    position: relative;
    overflow: hidden;
  }
  
  .empty-binders-state::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(circle, rgba(209,0,0,0.1) 0%, transparent 70%);
    animation: rotate 20s linear infinite;
  }
  
  @keyframes rotate {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
  
  .empty-binders-icon {
    font-size: 5rem;
    margin-bottom: 1.5rem;
    animation: float 3s ease-in-out infinite;
    position: relative;
    z-index: 1;
  }
  
  @keyframes float {
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(-10px); }
  }
  
  .empty-binders-title {
    font-size: clamp(2rem, 5vw, 3rem);
    font-weight: 900;
    letter-spacing: -0.02em;
    background: linear-gradient(135deg, #fff, #ff9a9a);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    margin-bottom: 1rem;
    position: relative;
    z-index: 1;
  }
  
  .empty-binders-subtitle {
    font-size: 1.2rem;
    color: rgba(255,255,255,0.7);
    margin-bottom: 2rem;
    position: relative;
    z-index: 1;
  }
  
  .empty-binders-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 1.5rem;
    margin-top: 2rem;
    position: relative;
    z-index: 1;
  }
  
  .empty-binders-card {
    background: rgba(255,255,255,0.05);
    border: 1px solid rgba(209,0,0,0.2);
    border-radius: 16px;
    padding: 1.5rem 1rem;
    backdrop-filter: blur(10px);
    transition: transform 0.3s ease, border-color 0.3s ease;
  }
  
  .empty-binders-card:hover {
    transform: translateY(-5px);
    border-color: #D10000;
  }
  
  .empty-binders-card span {
    font-size: 2rem;
    display: block;
    margin-bottom: 0.5rem;
  }
  
  .empty-binders-card p {
    color: #fff;
    font-weight: 600;
    margin: 0;
  }
  
  .empty-binders-card small {
    color: rgba(255,255,255,0.5);
    font-size: 0.8rem;
  }
  
  .empty-binders-refresh {
    background: linear-gradient(135deg, #D10000, #8B0000);
    color: white;
    border: none;
    padding: 1rem 2.5rem;
    font-size: 1.1rem;
    font-weight: 700;
    border-radius: 50px;
    cursor: pointer;
    margin-top: 2rem;
    position: relative;
    z-index: 1;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    border: 1px solid rgba(255,255,255,0.1);
  }
  
  .empty-binders-refresh:hover {
    transform: scale(1.05);
    box-shadow: 0 10px 25px rgba(209,0,0,0.4);
  }

  .empty-binders-hint {
  color: rgba(255,255,255,0.5);
  margin-bottom: 2rem;
  font-size: 1rem;
  position: relative;
  z-index: 1;
}
`;
(function addVendorPagination() {

  const VENDORS_PER_PAGE = 15;
  let currentPage = 1;
  let filteredEntries = [];

  const style = document.createElement('style');
  style.textContent = `
    .nb-pagination-wrap {
      width: 100%;
      padding: 1rem 1rem;
      box-sizing: border-box;
    }

    .nb-pagination-wrap.bottom {
      position: sticky;
      bottom: 0;
      background: rgba(8,8,8,0.97);
      backdrop-filter: blur(12px);
      -webkit-backdrop-filter: blur(12px);
      border-top: 1px solid rgba(255,77,77,0.15);
      z-index: 100;
      padding: 0.75rem 1rem;
    }

    .nb-pagination-inner {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
      flex-wrap: wrap;
    }

    .nb-page-btn {
      min-width: 38px;
      height: 38px;
      padding: 0 12px;
      border-radius: 10px;
      border: 1px solid rgba(255,77,77,0.25);
      background: linear-gradient(180deg, #1a1a1a, #111);
      color: #ccc;
      font-size: 0.88rem;
      font-weight: 700;
      cursor: pointer;
      transition: all 0.18s ease;
      display: flex;
      align-items: center;
      justify-content: center;
      white-space: nowrap;
      font-family: system-ui, sans-serif;
      box-sizing: border-box;
    }

    .nb-page-btn:hover:not(:disabled) {
      border-color: #ff4d4d;
      background: linear-gradient(180deg, #2a1a1a, #1a0a0a);
      color: #fff;
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(255,77,77,0.2);
    }

    .nb-page-btn:disabled {
      opacity: 0.25;
      cursor: not-allowed;
      transform: none;
    }

    .nb-page-btn.active {
      background: linear-gradient(135deg, #D10000, #8B0000);
      border-color: #ff4d4d;
      color: #fff;
      box-shadow: 0 4px 14px rgba(209,0,0,0.35);
      transform: translateY(-1px);
    }

    .nb-page-btn.nb-dots {
      background: transparent;
      border: none;
      color: #444;
      cursor: default;
      pointer-events: none;
      min-width: 24px;
      padding: 0;
    }

    .nb-page-info {
      color: #555;
      font-size: 0.78rem;
      font-weight: 600;
      text-align: center;
      padding: 0.35rem 0 0;
      letter-spacing: 0.04em;
      font-family: system-ui, sans-serif;
    }

    /* Mobile tweaks */
    @media (max-width: 600px) {
      .nb-page-btn {
        min-width: 34px;
        height: 34px;
        font-size: 0.8rem;
        padding: 0 8px;
        border-radius: 8px;
      }
      .nb-pagination-inner { gap: 4px; }
      .nb-pagination-wrap.bottom { padding: 0.6rem 0.75rem; }

      /* Hide middle page numbers on very small screens — keep prev/next/active */
      .nb-page-btn.nb-mid:not(.active) { display: none; }
    }
  `;
  document.head.appendChild(style);

  const vendorSection = document.getElementById('vendor-section');
  if (!vendorSection) return;

  // ── TOP pagination (above vendor section) ────────────────────────────────
  const topWrap = document.createElement('div');
  topWrap.id = 'nb-pagination-top';
  topWrap.className = 'nb-pagination-wrap top';
  topWrap.innerHTML = `<div class="nb-pagination-inner" id="nb-pg-inner-top"></div>
                       <p class="nb-page-info" id="nb-pg-info-top"></p>`;
  vendorSection.insertAdjacentElement('beforebegin', topWrap);

  // ── BOTTOM pagination (sticky bar below vendor section) ──────────────────
  const botWrap = document.createElement('div');
  botWrap.id = 'nb-pagination-bottom';
  botWrap.className = 'nb-pagination-wrap bottom';
  botWrap.innerHTML = `<div class="nb-pagination-inner" id="nb-pg-inner-bot"></div>
                       <p class="nb-page-info" id="nb-pg-info-bot"></p>`;
  vendorSection.insertAdjacentElement('afterend', botWrap);

  // ── Build pagination buttons into a container ────────────────────────────
  function buildButtons(innerEl, infoEl, totalPages) {
  if (!innerEl) return;
  innerEl.innerHTML = '';
  if (totalPages <= 1) return;

  // How many page number buttons fit based on screen width
  const w = window.innerWidth;
  const maxVisible = w < 360 ? 3 : w < 480 ? 5 : w < 640 ? 7 : w < 900 ? 9 : totalPages;

  const prev = document.createElement('button');
  prev.className = 'nb-page-btn';
  prev.innerHTML = '←';
  prev.title = 'Anterior';
  prev.disabled = currentPage === 1;
  prev.addEventListener('click', () => goToPage(currentPage - 1));
  innerEl.appendChild(prev);

  // Build visible page list
  const pages = [];
  if (totalPages <= maxVisible) {
    for (let i = 1; i <= totalPages; i++) pages.push(i);
  } else {
    const half = Math.floor((maxVisible - 2) / 2); // slots around current
    let rangeStart = Math.max(2, currentPage - half);
    let rangeEnd   = Math.min(totalPages - 1, currentPage + half);

    // Adjust if range is too small
    if (rangeEnd - rangeStart < maxVisible - 4) {
      if (currentPage < totalPages / 2) rangeEnd = Math.min(totalPages - 1, rangeStart + maxVisible - 4);
      else rangeStart = Math.max(2, rangeEnd - (maxVisible - 4));
    }

    pages.push(1);
    if (rangeStart > 2) pages.push('...');
    for (let i = rangeStart; i <= rangeEnd; i++) pages.push(i);
    if (rangeEnd < totalPages - 1) pages.push('...');
    pages.push(totalPages);
  }

  pages.forEach(p => {
    const btn = document.createElement('button');
    if (p === '...') {
      btn.className = 'nb-page-btn nb-dots';
      btn.innerHTML = '···';
    } else {
      btn.className = 'nb-page-btn';
      btn.innerHTML = String(p);
      if (p === currentPage) btn.classList.add('active');
      btn.addEventListener('click', () => goToPage(p));
    }
    innerEl.appendChild(btn);
  });

  const next = document.createElement('button');
  next.className = 'nb-page-btn';
  next.innerHTML = '→';
  next.title = 'Siguiente';
  next.disabled = currentPage === totalPages;
  next.addEventListener('click', () => goToPage(currentPage + 1));
  innerEl.appendChild(next);

  if (infoEl) {
    const start = (currentPage - 1) * VENDORS_PER_PAGE + 1;
    const end   = Math.min(currentPage * VENDORS_PER_PAGE, filteredEntries.length);
    infoEl.textContent = `Página ${currentPage} de ${totalPages} · ${start}–${end} de ${filteredEntries.length} vendedores`;
  }
}
window.addEventListener('resize', () => {
  const totalPages = Math.ceil(filteredEntries.length / VENDORS_PER_PAGE);
  if (totalPages > 1) renderPagination(totalPages);
}, { passive: true });

  function renderPagination(totalPages) {
    const show = totalPages > 1;
    topWrap.style.display = show ? '' : 'none';
    botWrap.style.display = show ? '' : 'none';

    buildButtons(
      document.getElementById('nb-pg-inner-top'),
      document.getElementById('nb-pg-info-top'),
      totalPages
    );
    buildButtons(
      document.getElementById('nb-pg-inner-bot'),
      document.getElementById('nb-pg-info-bot'),
      totalPages
    );
  }

  // ── Go to page ───────────────────────────────────────────────────────────
  function goToPage(page) {
    const totalPages = Math.ceil(filteredEntries.length / VENDORS_PER_PAGE);
    currentPage = Math.max(1, Math.min(page, totalPages));
    applyPageVisibility();

    // Scroll to just above vendor section so top pagination is visible
    const target = topWrap || vendorSection;
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // ── Show/hide groups — never re-render ──────────────────────────────────
  function applyPageVisibility() {
    const container = document.getElementById('vendor-section');
    if (!container) return;

    const totalPages = Math.ceil(filteredEntries.length / VENDORS_PER_PAGE);
    const start = (currentPage - 1) * VENDORS_PER_PAGE;
    const end   = start + VENDORS_PER_PAGE;

    const visibleKeys = new Set(
      filteredEntries.slice(start, end).map(([key]) => key)
    );

    container.querySelectorAll('.vendor-group').forEach(group => {
      const key = group.dataset.vendorKey || group.dataset.company || '';
      group.style.display = visibleKeys.has(key) ? '' : 'none';
    });

    renderPagination(totalPages);
  }

  // ── Build filtered + sorted entry list ──────────────────────────────────
  function buildFilteredEntries() {
    const full   = window.__fullVendorData || {};
    const search = (window.currentGlobalSearch || '').toLowerCase();

    filteredEntries = Object.entries(full).filter(([key, bucket]) => {
      if (!search) return true;
      if (vendorSearchHaystack(bucket, key).includes(search)) return true;
      return (bucket.products || []).some(p =>
        (p.title || '').toLowerCase().includes(search) ||
        (p.tags  || []).some(t => String(t).toLowerCase().includes(search))
      );
    });

    filteredEntries.sort((a, b) => {
      const ra = Number(a[1]?.vendorRatingAvg ?? a[1]?.vendorRating ?? 0) || 0;
      const rb = Number(b[1]?.vendorRatingAvg ?? b[1]?.vendorRating ?? 0) || 0;
      if (rb !== ra) return rb - ra;
      return (a[1]?.vendorName || a[0]).localeCompare(b[1]?.vendorName || b[0]);
    });
  }

  // ── Wrap renderAllVendors ────────────────────────────────────────────────
  const _original = window.renderAllVendors;
  window.renderAllVendors = function () {
    buildFilteredEntries();
    currentPage = 1;
    _original.call(this);
    applyPageVisibility();
  };

  // ── Hook rating sorter ───────────────────────────────────────────────────
  const sorterObserver = new MutationObserver(() => {
    const sorter = document.getElementById('nb-rating-sorter');
    if (!sorter || sorter.__pgBound) return;
    sorter.__pgBound = true;
    sorter.addEventListener('click', () => {
      setTimeout(() => {
        buildFilteredEntries();
        currentPage = 1;
        applyPageVisibility();
      }, 0);
    });
  });
  sorterObserver.observe(document.body, { childList: true, subtree: true });

  // ── Initial render ───────────────────────────────────────────────────────
  if (Object.keys(window.__fullVendorData || {}).length) {
    window.renderAllVendors();
  }

})();
// Add the styles to the page
const styleSheet = document.createElement("style");
styleSheet.textContent = emptyStateStyles;
document.head.appendChild(styleSheet);

/* ===== Boot & events ===== */
async function init(data) {
  const modal = document.getElementById("binder-modal");
  const binderContent = document.getElementById("binder-content");
  const vendorSection = document.getElementById("vendor-section");
  const globalSearchInput = document.getElementById("global-search-input");
  const titleElement = document.querySelector('.binders-title')?.parentElement;
  
  // CRITICAL FIX: Check if binderContent exists before adding class
  if (binderContent) {
    binderContent.classList.add("slab-scope");
  }
  
  // Comprehensive empty state detection
  function isEmptyData(data) {
    // If no data at all
    if (!data) return true;
    
    // Check for explicit empty flag from backend
    if (data._empty === true) return true;
    
    // Check for empty object
    if (typeof data === 'object' && Object.keys(data).length === 0) return true;
    
    // Check if it's an array with no items
    if (Array.isArray(data) && data.length === 0) return true;
    
    // Check if all vendors have empty products
    if (typeof data === 'object' && !Array.isArray(data)) {
      const vendors = Object.values(data);
      
      // If there are no vendors at all
      if (vendors.length === 0) return true;
      
      // Check if any vendor has actual products
      const hasProducts = vendors.some(vendor => 
        vendor && 
        typeof vendor === 'object' && 
        Array.isArray(vendor.products) && 
        vendor.products.length > 0
      );
      
      // If no vendors have products, consider it empty
      if (!hasProducts) return true;
    }
    
    return false;
  }
  
  // Handle empty state with enhanced detection
  if (isEmptyData(data)) {
    console.log('✨ Showing empty binder state:', data?._message || 'No data');
    
    // Determine the type of empty state
    let emptyType = 'empty';
    let message = data?._message || 'Pronto tendremos binders disponibles para ti';
    let hint = data?._hint || '';
    
    if (data?._error === true) {
      emptyType = 'error';
      message = data?._message || 'Error de conexión';
      hint = data?._details || 'Intenta recargar la página';
    } else if (data?._empty === true) {
      emptyType = 'no-products';
    }
    
    // Clear the vendor section
    if (vendorSection) {
      vendorSection.innerHTML = '';
      
      // Create and add the empty state component with type
      const emptyState = createEmptyBinderState(message, hint, emptyType);
      vendorSection.appendChild(emptyState);
    }
    
    // Hide search bar if it exists
    if (globalSearchInput) {
      globalSearchInput.style.display = 'none';
    }
    
    // Hide the help badge
    const helpBadge = document.querySelector('.bulk-help-badge');
    if (helpBadge) helpBadge.style.display = 'none';
    
    // Hide the title if it exists
    if (titleElement) {
      titleElement.style.display = 'none';
    }
    
    window.__fullVendorData = {};
    return;
  }
  
  // Normal initialization with data - but verify vendors actually have products
  console.log('📊 Initializing with vendor data:', Object.keys(data || {}).length, 'vendors');
  
  // Check if this is a valid vendor data object with actual products
  if (typeof data === 'object' && Object.keys(data).length > 0) {
    // Verify that vendors actually have products
    const vendorsWithProducts = Object.values(data).filter(v => 
      v && typeof v === 'object' && Array.isArray(v.products) && v.products.length > 0
    );
    
    // If no vendors have products, show empty state
    if (vendorsWithProducts.length === 0) {
      console.log('⚠️ Found vendor objects but no products - showing empty state');
      
      // Clear the vendor section
      if (vendorSection) {
        vendorSection.innerHTML = '';
        
        // Create and add empty state
        const emptyState = createEmptyBinderState(
          'Vendedores sin productos',
          'Los vendedores aún no tienen productos asignados en el binder',
          'empty'
        );
        vendorSection.appendChild(emptyState);
      }
      
      // Hide search bar
      if (globalSearchInput) {
        globalSearchInput.style.display = 'none';
      }
      
      // Hide help badge
      const helpBadge = document.querySelector('.bulk-help-badge');
      if (helpBadge) helpBadge.style.display = 'none';
      
      // Hide title
      if (titleElement) {
        titleElement.style.display = 'none';
      }
      
      window.__fullVendorData = {};
      return;
    }
    
    console.log(`✅ Found ${vendorsWithProducts.length} vendors with products`);
  }
  
  window.__fullVendorData = data || {};
  window.currentGlobalSearch = "";
  window.currentGlobalSearchRaw = "";
  window.currentGridSize = getResponsiveGridSize();
  window.currentPage = 0;
  
  // Show and configure search
  if (globalSearchInput) {
    globalSearchInput.style.display = 'block';
    globalSearchInput.value = ''; // Clear any previous value
    
    // Remove existing listeners to avoid duplicates
    const newInput = globalSearchInput.cloneNode(true);
    globalSearchInput.parentNode.replaceChild(newInput, globalSearchInput);
    
    newInput.addEventListener("input", _binderDebounce((e) => {
      window.currentGlobalSearch = e.target.value.trim().toLowerCase();
      renderAllVendors();
    }, 160));
  }
  
  // Make sure help badge is visible
  const helpBadge = document.querySelector('.bulk-help-badge');
  if (helpBadge) helpBadge.style.display = 'inline-flex';
  
  // Make sure title is visible
  if (titleElement) {
    titleElement.style.display = 'flex';
  }
  
  renderAllVendors();
}

// CreateEmptyBinderState function with type support
function createEmptyBinderState(message, hint, type = 'empty') {
  try {
    const container = document.createElement('div');
    container.className = 'empty-binders-state';
    
    // Choose icon and title based on type
    let icon = '📦';
    let title = 'BINDERS EN CAMINO';
    
    if (type === 'error') {
      icon = '⚠️';
      title = 'ERROR DE CONEXIÓN';
    } else if (type === 'no-products') {
      icon = '🏪';
      title = 'SIN PRODUCTOS';
    } else if (type === 'loading') {
      icon = '⚡';
      title = 'CARGANDO...';
    }
    
    const displayMessage = message || 'Pronto tendremos binders disponibles para ti';
    const displayHint = hint || '';
    
    container.innerHTML = `
      <div class="empty-binders-icon">${icon}</div>
      <h2 class="empty-binders-title">${title}</h2>
      <p class="empty-binders-subtitle">${displayMessage}</p>
      ${displayHint ? `<p class="empty-binders-hint">${displayHint}</p>` : ''}
      
      <div class="empty-binders-grid">
        <div class="empty-binders-card">
          <span>⚡</span>
          <p>Próximamente</p>
          <small>Nuevos vendedores</small>
        </div>
        <div class="empty-binders-card">
          <span>🎴</span>
          <p>Tarjetas Exclusivas</p>
          <small>En preparación</small>
        </div>
        <div class="empty-binders-card">
          <span>🏆</span>
          <p>Graded Cards</p>
          <small>Muy pronto</small>
        </div>
        <div class="empty-binders-card">
          <span>✨</span>
          <p>Ofertas Especiales</p>
          <small>En camino</small>
        </div>
      </div>
      
      <button class="empty-binders-refresh" onclick="window.location.reload()">
        🔄 REINTENTAR
      </button>
    `;
    
    return container;
  } catch (e) {
    console.warn('Failed to create empty state:', e);
    const fallback = document.createElement('div');
    fallback.textContent = message || 'No hay binders disponibles';
    fallback.style.cssText = 'text-align:center;padding:2rem;color:#fff;';
    return fallback;
  }
}

/* ===== AIO adapter / legacy modal ===== */
function getAIOApi(){
  return (
    window.BinderAIO || window.BinderAllInOne || window.BinderModal ||
    window.BinderOneWindow || window.OneWindowModal || window.OneWindow ||
    window.openOneWindowModal || window.openOneWindow || null
  );
}
function getAIOBody(){
  const shells = [
    '.binder-aio[data-id="binder"]','.binder-aio.is-open',
    '.onewindow[data-id="binder"]','.onewindow.is-open',
    '#binder-aio','#onewindow-binder'
  ];
  let shell = null;
  for (const sel of shells){ shell = document.querySelector(sel); if (shell) break; }
  if (!shell) shell = document.querySelector('.binder-aio, .onewindow, .modal, [data-modal="binder"]') || null;
  if (!shell) return null;
  return (
    shell.querySelector('.binder-aio__body') ||
    shell.querySelector('.onewindow__body') ||
    shell.querySelector('[data-role="modal-body"]') ||
    shell.querySelector('.modal-body') ||
    shell
  );
}
function openWithAIO(title){
  const api = getAIOApi();
  if (!api) return { ok:false, close:()=>{} };

  try {
    if (typeof api.open === 'function') api.open({ id:'binder', title: title || 'NENSONS BINDERS', size:'fullscreen' });
    else if (typeof api === 'function') api({ id:'binder', title: title || 'NENSONS BINDERS', size:'fullscreen' });
    else if (typeof api.show === 'function') api.show({ id:'binder', title: title || 'NENSONS BINDERS', size:'fullscreen' });

    const body = getAIOBody();
    const binderContent = document.getElementById('binder-content');
    if (!body || !binderContent) return { ok:false, close:()=>{} };

body.innerHTML = '';
    body.appendChild(binderContent);
    document.documentElement.classList.add('binder-aio-active');
    document.body.classList.add('modal-open');
    document.documentElement.style.overflowY = 'hidden';
    document.body.style.overflowY = 'hidden';

    const close = () => {
      if (api.close) api.close('binder');
      else if (api.hide) api.hide('binder');
      else if (api.destroy) api.destroy('binder');
      else {
        const btn = document.querySelector('.binder-aio [data-close], .onewindow [data-close], .modal [data-close], .binder-aio .close, .onewindow .close, .modal .close');
        btn && btn.click();
      }
      const host = document.getElementById('binder-modal');
      const bc = document.getElementById('binder-content');
      if (host && bc && !host.contains(bc)) host.appendChild(bc);
document.documentElement.classList.remove('binder-aio-active');
      document.body.classList.remove('modal-open');
      document.documentElement.style.overflowY = '';
      document.body.style.overflowY = '';
    };

    window.addEventListener('binder-aio:close', () => { try { close(); } catch {} }, { once:true });
    return { ok:true, close };

  } catch {
    return { ok:false, close:()=>{} };
  }
}
function openLegacy(){
  const modal = document.getElementById('binder-modal');
  if (!modal) return { ok:false, close:()=>{} };

  modal.classList.add('is-open');
  modal.style.display='flex';
  modal.classList.toggle('force-desktop', !isMobileViewport());
  document.body.classList.add('modal-open');
  document.documentElement.style.overflowY = 'hidden';
  document.body.style.overflowY = 'hidden';

  const close = () => {
    modal.classList.remove('is-open');
    modal.style.display='none';
    modal.classList.remove('force-desktop');
    document.body.classList.remove('modal-open');
    document.documentElement.style.overflowY = '';
    document.body.style.overflowY = '';
  };
  return { ok:true, close };
}
window.__binderOpen  = function(title){
  const res=openWithAIO(title);
  if (res.ok){ window.__closeBinder=res.close; return res; }
  const fb=openLegacy(); window.__closeBinder=fb.close; return fb;
};
window.__binderClose = function(){
  try { window.__closeBinder && window.__closeBinder(); } catch {}
  // Drop ?store= so the list URL is clean again.
  // replaceState (not pushState) — closing shouldn't add a history entry.
  try {
    if (new URLSearchParams(location.search).has('store')) {
      history.replaceState({}, '', location.pathname);
    }
  } catch {}
    window.__binderVendorAutoOpened = false;
};

/* ===== Back / forward navigation ↔ binder open state ===== */
window.addEventListener('popstate', () => {
  const slug = storeSlug(new URLSearchParams(location.search).get('store') || '');
  const isOpen =
    document.documentElement.classList.contains('binder-aio-active') ||
    document.getElementById('binder-modal')?.classList.contains('is-open');

  if (!slug) {
    if (isOpen) window.__binderClose();
    return;
  }
  if (!isOpen) {
    window.__binderVendorAutoOpened = false;
    autoOpenBinderFromContext();
  }
});

/* ===== Install boot (cache-first, then fresh) ===== */
(function installBinderBoot(){
  if (window.__binderBooted) return;
  window.__binderBooted = true;

  const CACHE_KEY  = 'nb:vendors:v6';
const CACHE_META = 'nb:vendors:v6:meta';
  const CACHE_TTL  = 10 * 60 * 1000; // 10 minutes

  // ── READ with TTL check ──
  const raw      = sessionStorage.getItem(CACHE_KEY);
  const meta     = JSON.parse(sessionStorage.getItem(CACHE_META) || '{}');
  const age      = Date.now() - (meta.ts || 0);
  const isStale  = !raw || age > CACHE_TTL;

  function normalizeVendorGrouping(json){
    if (!json) return {};
    if (json.vendors && typeof json.vendors === 'object') return json.vendors;
    if (json.data && json.data.vendors && typeof json.data.vendors === 'object') return json.data.vendors;

    if (Array.isArray(json)){
      const out = {};
      json.forEach(row=>{
        const email = row?.vendorEmail || row?.email || row?.vendor || row?.key || '';
        if (!email) return;
        out[email] = out[email] || { vendorName: row.vendorName || email, email, products: [] };
        if (Array.isArray(row.products)) out[email].products.push(...row.products.map(mapBackendToCard));
      });
      return out;
    }
    const looksLikeMap = Object.values(json).some(v => typeof v === 'object' && ('products' in v || 'vendorName' in v));
    return looksLikeMap ? json : {};
  }

  async function tryFetchVendors() {
  const base = getApiBaseOrThrow();
  const customerEmail = canonicalizeEmail(window.CURRENT_CUSTOMER_EMAIL || "");
  const customerFirstName = String(window.CURRENT_CUSTOMER_FIRST_NAME || "").trim();
  const customerLastName = String(window.CURRENT_CUSTOMER_LAST_NAME || "").trim();

const params = new URLSearchParams();
  if (customerEmail) params.set("customerEmail", customerEmail);
  if (customerFirstName) params.set("customerFirstName", customerFirstName);
  if (customerLastName) params.set("customerLastName", customerLastName);
  const customerUserStore = String(window.CURRENT_CUSTOMER_USER_STORE || "").trim();
  if (customerUserStore) params.set("customerUserStore", customerUserStore);
  const qs = params.toString() ? `?${params.toString()}` : "";

  // CORRECT ENDPOINT - use group-products-by-vendor
  const EP_CANDIDATES = [
    `${base}/group-products-by-vendor${qs}`,  // Primary endpoint - returns grouped vendors
    `${base.replace(/\/api\/?$/, '')}/group-products-by-vendor${qs}`, // Without /api prefix
  ];
  
  let lastError = null;
  
  for (const url of EP_CANDIDATES) {
    try {
      console.log('🔍 Fetching from:', url);
      const r = await fetch(url, { headers: { Accept: 'application/json' } });
      
      if (r.ok) {
        const data = await r.json();
        console.log('✅ API response:', data);
        
        // Check for empty state response from backend
        if (data && data._empty === true) {
          console.log('📭 Backend returned empty state:', data._message);
          return data; // Return the empty state object directly
        }
        
        // Check if this is already a vendor-grouped object (what we want)
        if (data && typeof data === 'object' && !Array.isArray(data)) {
          // Verify it has at least one vendor with products
          const hasVendors = Object.keys(data).length > 0;
          
          if (hasVendors) {
            // Check if vendors actually have products
            const vendorsWithProducts = Object.values(data).some(v => 
              v && typeof v === 'object' && Array.isArray(v.products) && v.products.length > 0
            );
            
            if (vendorsWithProducts) {
              console.log('✅ Received vendor-grouped data with products');
              return data; // Return the grouped data directly
            } else {
              console.log('⚠️ Vendor objects exist but no products');
              return {
                _empty: true,
                _message: 'Vendedores sin productos',
                _hint: 'Los vendedores aún no tienen productos asignados'
              };
            }
          }
        }
        
        // Handle the list-binder-products format (fallback)
        if (data && data.success === true && Array.isArray(data.products)) {
          console.log('📦 Found products in list format:', data.products.length);
          
          if (data.products.length === 0) {
            return { 
              _empty: true, 
              _message: 'No hay productos en el binder',
              _hint: 'El binder nenson-binder está vacío'
            };
          }
          
          // Transform flat products to vendor-grouped format
          const grouped = {};
          let hasValidVendors = false;
          
          for (const product of data.products) {
            const vendorEmail = 
              product.vendorEmail || 
              product.vendor_email || 
              product.email || 
              product.vendorCreatorEmail ||
              (product.metafields && product.metafields.vendor_creator_email) ||
              '';
            
            if (!vendorEmail || typeof vendorEmail !== 'string' || !vendorEmail.includes('@')) {
              console.log('⚠️ Skipping product without vendor email:', product.title || product.handle);
              continue;
            }
            
            hasValidVendors = true;
            const canonEmail = canonicalizeEmail(vendorEmail);
            
            if (!grouped[canonEmail]) {
              const vendorName = product.vendor || canonEmail.split('@')[0] || 'Vendedor';
              
              grouped[canonEmail] = {
                vendorName: vendorName,
                vendorLastName: vendorName,
                email: canonEmail,
                vendorKey: canonEmail,
                contactEmail: canonEmail,
                vendorRating: 0,
                vendorRatingCount: 0,
                vendorRatingTotal: 0,
                vendorRatingAvg: 0,
                articleHandle: `vendor-${canonEmail.split('@')[0]}`,
                articleUrl: `/blogs/vendedores/vendor-${canonEmail.split('@')[0]}`,
                products: []
              };
            }
            
            grouped[canonEmail].products.push(product);
          }
          
          if (!hasValidVendors) {
            return { 
              _empty: true, 
              _message: 'No hay productos con vendedores válidos',
              _hint: 'Los productos necesitan tener un email de vendedor asignado'
            };
          }
          
          return grouped;
        }
        
        // If we got here but no recognizable format, return empty
        return { 
          _empty: true, 
          _message: 'No se encontraron productos',
          _hint: 'El binder no tiene productos asignados'
        };
      } else {
        lastError = `HTTP ${r.status}: ${r.statusText}`;
        console.warn(`⚠️ Endpoint ${url} returned ${r.status}`);
      }
    } catch (e) {
      lastError = e.message;
      console.warn(`⚠️ Failed to fetch from ${url}:`, e.message);
    }
  }
  
  console.error('❌ All endpoints failed:', lastError);
  return { 
    _empty: true, 
    _message: 'Servicio temporalmente no disponible',
    _hint: 'Intenta recargar la página',
    _error: lastError 
  };
}

  async function start(){
    console.log('🚀 Starting binder boot...');
    
    // CRITICAL FIX: Always show something immediately
    const vendorSection = document.getElementById('vendor-section');
    if (vendorSection) {
      // Show a "Loading" state immediately
      vendorSection.innerHTML = `
        <div style="grid-column:1/-1; text-align:center; padding:4rem; color:#fff;">
          <div style="font-size:3rem; margin-bottom:1rem;">⚡</div>
          <h3 style="font-size:1.5rem; margin-bottom:1rem;">Cargando binders...</h3>
          <p style="color:#aaa;">Por favor espera un momento</p>
        </div>
      `;
    }
    
    try {
      // ── 1. Try cache first ──
      if (raw && !isStale) {
        const cached = JSON.parse(raw);
        console.log('📦 Cache found:', cached);
        
        // Check if cache contains empty state marker
        if (cached && cached._empty === true) {
          console.log('📭 Cache contains empty state');
          init(cached); // Pass directly to init
        } 
        // Check if cache has real vendor data
        else if (cached && Object.keys(cached).length > 0) {
          console.log('📦 Using cached vendor data');
          window.__fullVendorData = cached;
          init(cached);
        } 
        // Cache is empty/invalid
        else {
          console.log('🔄 Cache empty, showing empty state');
          init({ _empty: true, _message: 'No hay binders disponibles', _hint: 'Pronto tendremos novedades' });
        }
        
        autoOpenBinderFromContext();
        Sched.raf(()=>{ try{ mountSlabs(document); }catch{} });
      } else {
        // No cache or stale — show loading state while we fetch
        console.log('🔄 No valid cache, showing loading state');
        init({ _empty: true, _message: 'Cargando binders...', _hint: 'Conectando con el servidor' });
        autoOpenBinderFromContext();
      }
    } catch (e) {
      console.warn('⚠️ Cache parse error:', e);
      init({ _empty: true, _message: 'Error al cargar cache', _hint: 'Recarga la página' });
      autoOpenBinderFromContext();
    }

    // ── 2. Always refresh from API ──
    try {
      console.log('🌐 Fetching fresh data from API...');
      const freshData = await tryFetchVendors();
      console.log('📦 Fresh data received:', freshData);
      
      // Case 1: API returned empty state with _empty flag
      if (freshData && freshData._empty === true) {
        console.log('📭 API returned empty state:', freshData._message);
        
        // Cache the empty state
        sessionStorage.setItem(CACHE_KEY, JSON.stringify(freshData));
        sessionStorage.setItem(CACHE_META, JSON.stringify({ ts: Date.now() }));
        
        // PASS DIRECTLY TO INIT - NO TRANSFORMATION
        init(freshData);
      } 
      // Case 2: API returned empty object (backward compatibility)
      else if (freshData && typeof freshData === 'object' && Object.keys(freshData).length === 0) {
        console.log('📭 API returned empty object');
        
        const emptyState = { 
          _empty: true, 
          _message: 'No hay binders disponibles',
          _hint: 'Pronto tendremos novedades'
        };
        
        sessionStorage.setItem(CACHE_KEY, JSON.stringify(emptyState));
        sessionStorage.setItem(CACHE_META, JSON.stringify({ ts: Date.now() }));
        
        init(emptyState);
      }
      // Case 3: Real vendor data
      else if (freshData && typeof freshData === 'object' && Object.keys(freshData).length > 0) {
        console.log('✅ API returned real vendor data with', Object.keys(freshData).length, 'vendors');
        
        // Normalize the data
        let fresh = normalizeVendorGrouping(freshData) || {};
        for (const k of Object.keys(fresh)){
          if (Array.isArray(fresh[k]?.products))
            fresh[k].products = fresh[k].products.map(mapBackendToCard);
        }

        // Cache the fresh data
        sessionStorage.setItem(CACHE_KEY, JSON.stringify(fresh));
        sessionStorage.setItem(CACHE_META, JSON.stringify({ ts: Date.now() }));

        window.__fullVendorData = fresh;
        init(fresh);
      }
      // Case 4: Unexpected format
      else {
        console.log('⚠️ API returned unexpected data format:', freshData);
        init({ 
          _empty: true, 
          _message: 'Formato de datos inesperado',
          _hint: 'Contacta a soporte'
        });
      }
      
      autoOpenBinderFromContext();
      Sched.raf(()=>{ try{ mountSlabs(document); }catch{} });

    } catch(err) {
      console.warn('⚠️ API fetch failed:', err);
      
      // CRITICAL FIX: Always show something even on error
      const emptyState = { 
        _empty: true, 
        _message: 'Error de conexión',
        _hint: 'Intenta recargar la página'
      };
      
      // Don't cache errors
      init(emptyState);
      autoOpenBinderFromContext();
    }
  }
  
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', start, { once:true });
  } else {
    // CRITICAL FIX: Ensure start runs even if DOM already loaded
    setTimeout(start, 10);
  }
})();

/* Smooth scrolling hint */
(function boostScrolling(){
  const root = document.documentElement;
  let clearT = null;
  const mark = ()=>{
    if (!root.hasAttribute('data-scrolling')) root.setAttribute('data-scrolling','1');
    clearTimeout(clearT);
    clearT = setTimeout(()=>{ root.removeAttribute('data-scrolling'); }, 140);
  };
  const passive = { passive:true };
  window.addEventListener('scroll', mark, passive);

  const attach = (el)=>{
    if (el && !el.__smoothHook){
      el.addEventListener('scroll', mark, passive);
      el.__smoothHook = true;
    }
  };
  attach(document.getElementById('binder-content'));
  document.querySelectorAll('.carousel').forEach(attach);

  const mo = new MutationObserver(()=>{
    document.querySelectorAll('.carousel').forEach(attach);
  });
  mo.observe(document.body, { childList:true, subtree:true });
})();
      })();
      break;
    case "drag-ghost":
      (function () {

/* =========================================================
   DRAG GHOST FINAL (adaptive per hovered drop-cell)
   - Background snapshot + img fallback
   - Brief "is-snapshot" during setDragImage for Safari/FF
   - Resizes to hovered grid cell while preserving AR
========================================================= */
(function customDragGhostFinal(){
  let ghostEl = null;
  let dragAR = 4/3;
  let dragSrc = "";
  let rafTicking = false;
  let lastSizeKey = "";

  function cleanup(){
    try{
      if (ghostEl && ghostEl.parentNode) ghostEl.parentNode.removeChild(ghostEl);
    }catch{}
    ghostEl = null;
    dragSrc = "";
    lastSizeKey = "";
  }

  function findCard(target){
    return target?.closest?.('.carousel-card') || target?.closest?.('.product-image-wrapper');
  }

  function getSourceImage(card){
    return (
      card.querySelector('.slab-window img') ||
      card.querySelector('.product-image-wrapper img') ||
      card.querySelector('img')
    );
  }

  function computeAspectRatio(img){
    const natW = img?.naturalWidth || 0;
    const natH = img?.naturalHeight || 0;
    if (natW > 0 && natH > 0) return natH / natW;

    const r = img?.getBoundingClientRect?.();
    if (r && r.width > 4 && r.height > 4){
      const renderedAR = r.height / r.width;
      if (renderedAR > 0.88 && renderedAR < 1.12) return 4/3;
      return renderedAR;
    }
    return 4/3;
  }

  function makeGhost(src, gw, gh){
    const ghost = document.createElement('div');
    ghost.className = 'drag-ghost drag-ghost-bg';
    ghost.style.setProperty('--ghost-w', gw + 'px');
    ghost.style.setProperty('--ghost-h', gh + 'px');
    ghost.style.width  = gw + 'px';
    ghost.style.height = gh + 'px';
    ghost.setAttribute('aria-hidden','true');

    // background snapshot (contain-fit)
    const safeSrc = String(src).replace(/"/g, "%22");
    ghost.style.backgroundImage = `url("${safeSrc}")`;

    // IMG fallback (browsers that snapshot only children)
    const img = document.createElement('img');
    img.src = src;
    img.alt = '';
    img.draggable = false;
    img.decoding = 'async';
    ghost.appendChild(img);

    return ghost;
  }

  function snapshotSetDragImage(e, gw, gh){
    if (!ghostEl || !e?.dataTransfer) return;
    ghostEl.classList.add('is-snapshot');
    ghostEl.getBoundingClientRect(); // force paint in-viewport
    try{
      e.dataTransfer.setDragImage(ghostEl, gw/2, gh/2);
    }catch{}
    requestAnimationFrame(()=>{
      if (ghostEl) ghostEl.classList.remove('is-snapshot');
    });
  }

  function resizeGhost(gw, gh, e){
    if (!ghostEl || !e?.dataTransfer) return;
    const key = gw + "x" + gh;
    if (key === lastSizeKey) return;
    lastSizeKey = key;

    ghostEl.style.setProperty('--ghost-w', gw + 'px');
    ghostEl.style.setProperty('--ghost-h', gh + 'px');
    ghostEl.style.width  = gw + 'px';
    ghostEl.style.height = gh + 'px';

    snapshotSetDragImage(e, gw, gh);
  }

  function findGridCell(target){
    return target?.closest?.('.grid-section > div') || target?.closest?.('.grid-section div[data-slot]') || null;
  }

  function adaptToHoverCell(e){
    rafTicking = false;
    if (!ghostEl) return;

    const cell = findGridCell(e.target);
    if (!cell) return;

    const r = cell.getBoundingClientRect();
    if (!(r.width > 10 && r.height > 10)) return;

    let gw = Math.round(r.width);
    let gh = Math.round(gw * dragAR);
    if (gh > r.height){
      gh = Math.round(r.height);
      gw = Math.round(gh / dragAR);
    }

    gw = Math.max(40, gw);
    gh = Math.max(40, gh);

    resizeGhost(gw, gh, e);
  }

  function scheduleAdapt(e){
    if (rafTicking) return;
    rafTicking = true;
    requestAnimationFrame(()=> adaptToHoverCell(e));
  }

  document.addEventListener('dragstart', (e)=>{
    const card = findCard(e.target);
    if (!card || !e.dataTransfer) return;

    const hostCard = card.closest('.carousel-card') || card;
    if (hostCard.draggable === false || hostCard.getAttribute('draggable') === 'false') return;

    try{
      e.dataTransfer.effectAllowed = 'move';
      e.dataTransfer.setData(
        'text/plain',
        hostCard.dataset.gid ||
        hostCard.querySelector('.add-to-cart-btn')?.dataset.handle ||
        hostCard.querySelector('a[href*="/products/"]')?.getAttribute('href') ||
        ''
      );
    }catch{}

    const boxEl = hostCard.querySelector('.product-image-wrapper') || hostCard;
    const r = boxEl.getBoundingClientRect();

    const srcImg = getSourceImage(hostCard);
    dragSrc = srcImg?.currentSrc || srcImg?.src || '';
    if (!dragSrc) return;

    dragAR = computeAspectRatio(srcImg);
    if (!Number.isFinite(dragAR) || dragAR < 1.1 || dragAR > 1.6) dragAR = 4/3;

    const gw0 = Math.round(Math.min(220, Math.max(120, r.width || 140)));
    const gh0 = Math.round(gw0 * dragAR);

    ghostEl = makeGhost(dragSrc, gw0, gh0);
    document.body.appendChild(ghostEl);
    ghostEl.getBoundingClientRect(); // initial paint

    snapshotSetDragImage(e, gw0, gh0);
  }, true);

  document.addEventListener('dragenter', scheduleAdapt, true);
  document.addEventListener('dragover',  scheduleAdapt, true);

  document.addEventListener('dragend', cleanup, true);
  document.addEventListener('drop', cleanup, true);
})();

// Wire submenu back buttons
(function wireSubmenuBack(){
  function wire(){
    document.querySelectorAll('#menu-drawer .menu-drawer__close-button').forEach(btn => {
      if (btn.__wired) return;
      btn.__wired = true;
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const details = btn.closest('details');
        if (details) details.removeAttribute('open');
      });
    });
  }

  // Wire on load
  wire();

  // Re-wire if drawer content changes
  const drawer = document.getElementById('menu-drawer');
  if (drawer) {
    new MutationObserver(wire).observe(drawer, { childList: true, subtree: true });
  }
})();
      })();
      break;
    case "sticky-bar":
      (function () {

(function initBinderStickyBar() {
  var stickyBar     = document.getElementById('nb-binder-sticky-bar');
  var stickyInput   = document.getElementById('nb-binder-sticky-input');
  var stickySorter  = document.getElementById('nb-sticky-sorter-clone');

  if (!stickyBar || !stickyInput || !stickySorter) return;

  /* ── Show / hide on scroll ── */
  var realSearchBar = document.getElementById('global-search-bar');

  function applyVisibility() {
    if (!realSearchBar) {
      realSearchBar = document.getElementById('global-search-bar');
    }
    var threshold = 80;
    if (realSearchBar) {
      var rect = realSearchBar.getBoundingClientRect();
      threshold = rect.bottom + (window.scrollY || window.pageYOffset) - 10;
    }
    var scrolled = (window.scrollY || window.pageYOffset) > threshold;
    stickyBar.classList.toggle('is-visible', scrolled);
  }

  window.addEventListener('scroll', applyVisibility, { passive: true });
  window.addEventListener('resize', applyVisibility, { passive: true });
  applyVisibility();

  /* ── Sync sticky input → real search input (bidirectional) ── */
  var _debounceT = null;

  function syncFromSticky() {
    var val = stickyInput.value;
    var realInput = document.getElementById('global-search-input');
    if (!realInput) return;

    if (realInput.value !== val) {
      realInput.value = val;
      /* Dispatch input event so the existing debounce handler picks it up */
      realInput.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  stickyInput.addEventListener('input', function () {
    clearTimeout(_debounceT);
    _debounceT = setTimeout(syncFromSticky, 160);
  });

  stickyInput.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') {
      clearTimeout(_debounceT);
      syncFromSticky();
    }
  });

  /* Mirror real input changes back to sticky (e.g. reset button) */
  document.addEventListener('input', function (e) {
    if (e.target && e.target.id === 'global-search-input') {
      if (stickyInput.value !== e.target.value) {
        stickyInput.value = e.target.value;
      }
    }
  });

  /* Also catch programmatic clears (reset btn sets value then dispatches) */
  var resetBtn = document.getElementById('binder-reset-btn');
  if (resetBtn) {
    resetBtn.addEventListener('click', function () {
      setTimeout(function () { stickyInput.value = ''; }, 0);
    });
  }
  /* Watch for reset button injected later */
  if (!resetBtn) {
    var resetObserver = new MutationObserver(function () {
      var btn = document.getElementById('binder-reset-btn');
      if (btn && !btn.__stickyBound) {
        btn.__stickyBound = true;
        btn.addEventListener('click', function () {
          setTimeout(function () { stickyInput.value = ''; }, 0);
        });
        resetObserver.disconnect();
      }
    });
    resetObserver.observe(document.body, { childList: true, subtree: true });
  }

  /* ── Rating sorter clone ── */
  /* Mirror the real sorter's sort direction and trigger it */
  var sortDir = 'desc';

  stickySorter.addEventListener('click', function () {
    /* Find the real sorter and click it to keep state in sync */
    var realSorter = document.getElementById('nb-rating-sorter');
    if (realSorter) {
      realSorter.click();
      /* Read the direction it switched to from button text */
      setTimeout(function () {
        var txt = realSorter.innerHTML || '';
        var isAsc = txt.indexOf('↑') !== -1;
        sortDir = isAsc ? 'asc' : 'desc';
        stickySorter.innerHTML = sortDir === 'desc' ? '★ Rating ↓' : '★ Rating ↑';
      }, 50);
    } else {
      /* Real sorter not yet in DOM — run sort logic directly */
      sortDir = sortDir === 'desc' ? 'asc' : 'desc';
      stickySorter.innerHTML = sortDir === 'desc' ? '★ Rating ↓' : '★ Rating ↑';

      var full = window.__fullVendorData || {};
      var entries = Object.entries(full);
      entries.sort(function (a, b) {
        var ra = Number(a[1]?.vendorRatingAvg ?? a[1]?.vendorRating ?? 0) || 0;
        var rb = Number(b[1]?.vendorRatingAvg ?? b[1]?.vendorRating ?? 0) || 0;
        return sortDir === 'desc' ? rb - ra : ra - rb;
      });

      var container = document.getElementById('vendor-section');
      if (container) {
        entries.forEach(function (pair) {
          var group = container.querySelector(
            '.vendor-group[data-vendor-key="' + CSS.escape(pair[0]) + '"],' +
            '.vendor-group[data-company="' + CSS.escape(pair[1].vendorName || pair[0]) + '"]'
          );
          if (group) container.appendChild(group);
        });
      }
    }
  });

  /* Keep sticky sorter label in sync when the real one changes */
  var realSorterObserver = new MutationObserver(function () {
    var realSorter = document.getElementById('nb-rating-sorter');
    if (!realSorter) return;
    var txt = realSorter.innerHTML || '';
    var isAsc = txt.indexOf('↑') !== -1;
    var newDir = isAsc ? 'asc' : 'desc';
    if (newDir !== sortDir) {
      sortDir = newDir;
      stickySorter.innerHTML = sortDir === 'desc' ? '★ Rating ↓' : '★ Rating ↑';
    }
  });
  realSorterObserver.observe(document.body, { childList: true, subtree: true, characterData: true });

})();
      })();
      break;
    case "visibility-patch":
      (function () {

(function patchBinderVisibility(){
  const HIDE_SELECTORS = [
    '#nb-binder-sticky-bar',
    '#nb-vendors-scroll-top',
    '.nn-back-btn',
  ];

  function setHidden(hide){
    HIDE_SELECTORS.forEach(sel => {
      document.querySelectorAll(sel).forEach(el => {
        if (hide) {
          el.style.setProperty('display', 'none', 'important');
        } else {
          el.style.removeProperty('display');
        }
      });
    });
  }

  // MutationObserver on html + body class — most reliable trigger
  // binder-aio-active / modal-open are added by the existing binder code
  const observer = new MutationObserver(() => {
    const isOpen =
      document.documentElement.classList.contains('binder-aio-active') ||
      document.body.classList.contains('modal-open');
    setHidden(isOpen);
  });
  observer.observe(document.documentElement, { attributeFilter: ['class'] });
  observer.observe(document.body,            { attributeFilter: ['class'] });

  // Also wrap __binderOpen / __binderClose directly
  function hookFunctions(){
    if (window.__binderOpen && !window.__binderOpen.__patched){
      const orig = window.__binderOpen;
      window.__binderOpen = function(title){
        setHidden(true);
        return orig.call(this, title);
      };
      window.__binderOpen.__patched = true;
    }
    if (window.__binderClose && !window.__binderClose.__patched){
      const orig = window.__binderClose;
      window.__binderClose = function(){
        setHidden(false);
        return orig.call(this);
      };
      window.__binderClose.__patched = true;
    }
  }

  hookFunctions();

  // Poll until the functions are defined (they load after this script)
  if (!window.__binderOpen || !window.__binderClose){
    const poll = setInterval(() => {
      hookFunctions();
      if (window.__binderOpen?.__patched &&
          window.__binderClose?.__patched) clearInterval(poll);
    }, 80);
  }
})();
      })();
      break;
    default:
      if (stage) console.warn("[user-stores.js] Unknown stage:", stage);
      break;
  }
})();


/* ===== FINAL: permanently remove banner Share, including delayed async inserts ===== */
(function removeDelayedBannerShare() {
  function clean(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var groups = scope.matches && scope.matches('.vendor-group')
      ? [scope]
      : Array.from(scope.querySelectorAll ? scope.querySelectorAll('.vendor-group') : []);

    groups.forEach(function(group) {
      var banner = group.querySelector('.vendor-button, .vendor-banner, .vendor-header');
      if (!banner) return;

      banner.querySelectorAll(
        'button, a, [role="button"], .vendor-share-cta'
      ).forEach(function(el) {

        // NEVER remove the Share button in the bottom action row
        if (el.closest('.vendor-actions-row')) return;

        var txt = (el.textContent || '').trim().toLowerCase();
        var aria = (el.getAttribute('aria-label') || '').trim().toLowerCase();
        var cls = (el.className || '').toString().toLowerCase();

        if (
          el.classList.contains('vendor-share-cta') ||
          txt === 'share' ||
          txt === 'compartir' ||
          aria.includes('share') ||
          aria.includes('compartir') ||
          cls.includes('share')
        ) {
          el.remove();
        }
      });
    });
  }

  // Remove any banner Share already present
  clean(document);

  // Permanently watch for delayed injections
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      m.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) clean(node);
      });
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
